// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { fieldMaskFromJson, fieldMaskToJson, pagedRequestOptionsFromJson, pagedRequestOptionsToJson, pagedResponseMetadataFromJson, pagedResponseMetadataToJson } from '../../vendastatypes/codec';
export function keyValuePairToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function keyValuePairFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function namespaceToJson(m) {
    const o = {};
    if (m.namespace !== undefined) {
        if (m.namespace.type === 'accountGroupNamespace') {
            o['accountGroupNamespace'] = namespaceAccountGroupNamespaceToJson(m.namespace.accountGroupNamespace);
        }
        if (m.namespace.type === 'partnerNamespace') {
            o['partnerNamespace'] = namespacePartnerNamespaceToJson(m.namespace.partnerNamespace);
        }
        if (m.namespace.type === 'systemNamespace') {
            o['systemNamespace'] = namespaceSystemNamespaceToJson(m.namespace.systemNamespace);
        }
        if (m.namespace.type === 'globalNamespace') {
            o['globalNamespace'] = namespaceGlobalNamespaceToJson(m.namespace.globalNamespace);
        }
        if (m.namespace.type === 'groupNamespace') {
            o['groupNamespace'] = namespaceGroupNamespaceToJson(m.namespace.groupNamespace);
        }
    }
    else {
        if (m.accountGroupNamespace !== undefined)
            o['accountGroupNamespace'] = namespaceAccountGroupNamespaceToJson(m.accountGroupNamespace);
        if (m.partnerNamespace !== undefined)
            o['partnerNamespace'] = namespacePartnerNamespaceToJson(m.partnerNamespace);
        if (m.systemNamespace !== undefined)
            o['systemNamespace'] = namespaceSystemNamespaceToJson(m.systemNamespace);
        if (m.globalNamespace !== undefined)
            o['globalNamespace'] = namespaceGlobalNamespaceToJson(m.globalNamespace);
        if (m.groupNamespace !== undefined)
            o['groupNamespace'] = namespaceGroupNamespaceToJson(m.groupNamespace);
    }
    return o;
}
export function namespaceFromJson(o) {
    return {
        namespace: (() => {
            if (o['accountGroupNamespace'] !== undefined)
                return { type: 'accountGroupNamespace', accountGroupNamespace: o['accountGroupNamespace'] ? namespaceAccountGroupNamespaceFromJson(o['accountGroupNamespace']) : undefined };
            if (o['partnerNamespace'] !== undefined)
                return { type: 'partnerNamespace', partnerNamespace: o['partnerNamespace'] ? namespacePartnerNamespaceFromJson(o['partnerNamespace']) : undefined };
            if (o['systemNamespace'] !== undefined)
                return { type: 'systemNamespace', systemNamespace: o['systemNamespace'] ? namespaceSystemNamespaceFromJson(o['systemNamespace']) : undefined };
            if (o['globalNamespace'] !== undefined)
                return { type: 'globalNamespace', globalNamespace: o['globalNamespace'] ? namespaceGlobalNamespaceFromJson(o['globalNamespace']) : undefined };
            if (o['groupNamespace'] !== undefined)
                return { type: 'groupNamespace', groupNamespace: o['groupNamespace'] ? namespaceGroupNamespaceFromJson(o['groupNamespace']) : undefined };
            return undefined;
        })(),
        accountGroupNamespace: o['accountGroupNamespace'] !== undefined ? o['accountGroupNamespace'] ? namespaceAccountGroupNamespaceFromJson(o['accountGroupNamespace']) : undefined : undefined,
        partnerNamespace: o['partnerNamespace'] !== undefined ? o['partnerNamespace'] ? namespacePartnerNamespaceFromJson(o['partnerNamespace']) : undefined : undefined,
        systemNamespace: o['systemNamespace'] !== undefined ? o['systemNamespace'] ? namespaceSystemNamespaceFromJson(o['systemNamespace']) : undefined : undefined,
        globalNamespace: o['globalNamespace'] !== undefined ? o['globalNamespace'] ? namespaceGlobalNamespaceFromJson(o['globalNamespace']) : undefined : undefined,
        groupNamespace: o['groupNamespace'] !== undefined ? o['groupNamespace'] ? namespaceGroupNamespaceFromJson(o['groupNamespace']) : undefined : undefined,
    };
}
export function namespaceAccountGroupNamespaceToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function namespaceAccountGroupNamespaceFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function namespacePartnerNamespaceToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function namespacePartnerNamespaceFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function namespaceSystemNamespaceToJson(m) {
    const o = {};
    return o;
}
export function namespaceSystemNamespaceFromJson(o) {
    return {};
}
export function namespaceGlobalNamespaceToJson(m) {
    const o = {};
    return o;
}
export function namespaceGlobalNamespaceFromJson(o) {
    return {};
}
export function namespaceGroupNamespaceToJson(m) {
    const o = {};
    if (m.groupId !== undefined)
        o['groupId'] = m.groupId;
    return o;
}
export function namespaceGroupNamespaceFromJson(o) {
    var _a;
    return {
        groupId: (_a = o['groupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function chatContentToJson(m) {
    const o = {};
    if (m.contentType !== undefined) {
        if (m.contentType.type === 'text') {
            o['text'] = m.contentType.text;
        }
        if (m.contentType.type === 'image') {
            o['image'] = imageContentToJson(m.contentType.image);
        }
    }
    else {
        if (m.text !== undefined)
            o['text'] = m.text;
        if (m.image !== undefined)
            o['image'] = imageContentToJson(m.image);
    }
    return o;
}
export function chatContentFromJson(o) {
    return {
        contentType: (() => {
            if (o['text'] !== undefined)
                return { type: 'text', text: o['text'] };
            if (o['image'] !== undefined)
                return { type: 'image', image: o['image'] ? imageContentFromJson(o['image']) : undefined };
            return undefined;
        })(),
        text: o['text'] !== undefined ? o['text'] : undefined,
        image: o['image'] !== undefined ? o['image'] ? imageContentFromJson(o['image']) : undefined : undefined,
    };
}
export function toolCallToJson(m) {
    const o = {};
    if (m.toolName !== undefined)
        o['toolName'] = m.toolName;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.arguments !== undefined)
        o['arguments'] = m.arguments;
    if (m.response !== undefined)
        o['response'] = m.response;
    if (m.noOp !== undefined)
        o['noOp'] = m.noOp;
    if (m.sessionEventId !== undefined)
        o['sessionEventId'] = m.sessionEventId;
    return o;
}
export function toolCallFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        toolName: (_a = o['toolName']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        arguments: (_b = o['arguments']) !== null && _b !== void 0 ? _b : '',
        response: (_c = o['response']) !== null && _c !== void 0 ? _c : '',
        noOp: (_d = o['noOp']) !== null && _d !== void 0 ? _d : false,
        sessionEventId: (_e = o['sessionEventId']) !== null && _e !== void 0 ? _e : '',
    };
}
export function imageContentToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.mediaType !== undefined)
        o['mediaType'] = m.mediaType;
    if (m.altText !== undefined)
        o['altText'] = m.altText;
    return o;
}
export function imageContentFromJson(o) {
    var _a, _b, _c;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        mediaType: (_b = o['mediaType']) !== null && _b !== void 0 ? _b : '',
        altText: (_c = o['altText']) !== null && _c !== void 0 ? _c : '',
    };
}
export function chatMessageToJson(m) {
    const o = {};
    if (m.role !== undefined)
        o['role'] = m.role;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.contentParts !== undefined) {
        o['contentParts'] = m.contentParts.map(e => chatContentToJson(e));
    }
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    return o;
}
export function chatMessageFromJson(o) {
    var _a, _b, _c, _d;
    return {
        role: (_a = o['role']) !== null && _a !== void 0 ? _a : 'CHAT_MESSAGE_ROLE_INVALID',
        content: (_b = o['content']) !== null && _b !== void 0 ? _b : '',
        contentParts: ((_c = o['contentParts']) !== null && _c !== void 0 ? _c : []).map(e => chatContentFromJson(e)),
        externalId: (_d = o['externalId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function chatUserInfoToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.phone !== undefined)
        o['phone'] = m.phone;
    if (m.address1 !== undefined)
        o['address1'] = m.address1;
    if (m.address2 !== undefined)
        o['address2'] = m.address2;
    if (m.city !== undefined)
        o['city'] = m.city;
    if (m.state !== undefined)
        o['state'] = m.state;
    if (m.country !== undefined)
        o['country'] = m.country;
    if (m.zipCode !== undefined)
        o['zipCode'] = m.zipCode;
    if (m.timezone !== undefined)
        o['timezone'] = m.timezone;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    return o;
}
export function chatUserInfoFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        email: (_b = o['email']) !== null && _b !== void 0 ? _b : '',
        phone: (_c = o['phone']) !== null && _c !== void 0 ? _c : '',
        address1: (_d = o['address1']) !== null && _d !== void 0 ? _d : '',
        address2: (_e = o['address2']) !== null && _e !== void 0 ? _e : '',
        city: (_f = o['city']) !== null && _f !== void 0 ? _f : '',
        state: (_g = o['state']) !== null && _g !== void 0 ? _g : '',
        country: (_h = o['country']) !== null && _h !== void 0 ? _h : '',
        zipCode: (_j = o['zipCode']) !== null && _j !== void 0 ? _j : '',
        timezone: (_k = o['timezone']) !== null && _k !== void 0 ? _k : '',
        userId: (_l = o['userId']) !== null && _l !== void 0 ? _l : '',
    };
}
export function contextInfoToJson(m) {
    const o = {};
    if (m.variables !== undefined) {
        o['variables'] = m.variables.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function contextInfoFromJson(o) {
    var _a;
    return {
        variables: ((_a = o['variables']) !== null && _a !== void 0 ? _a : []).map(e => keyValuePairFromJson(e)),
    };
}
export function chatAnswerFunctionExecutionJobResultToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function chatAnswerFunctionExecutionJobResultFromJson(o) {
    var _a, _b;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        metadata: ((_b = o['metadata']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
    };
}
export function chatAnswerFunctionExecutionJobToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.result !== undefined)
        o['result'] = chatAnswerFunctionExecutionJobResultToJson(m.result);
    if (m.nextJobId !== undefined)
        o['nextJobId'] = m.nextJobId;
    return o;
}
export function chatAnswerFunctionExecutionJobFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'FUNCTION_EXECUTION_JOB_STATUS_INVALID',
        result: o['result'] ? chatAnswerFunctionExecutionJobResultFromJson(o['result']) : undefined,
        nextJobId: (_c = o['nextJobId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function answerCitationToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.link !== undefined)
        o['link'] = m.link;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.contentSize !== undefined)
        o['contentSize'] = m.contentSize;
    if (m.contentSizeLimit !== undefined)
        o['contentSizeLimit'] = m.contentSizeLimit;
    if (m.fileUrl !== undefined)
        o['fileUrl'] = m.fileUrl;
    if (m.sourceNamespace !== undefined)
        o['sourceNamespace'] = namespaceToJson(m.sourceNamespace);
    return o;
}
export function answerCitationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'UNSPECIFIED',
        description: (_b = o['description']) !== null && _b !== void 0 ? _b : '',
        link: (_c = o['link']) !== null && _c !== void 0 ? _c : '',
        title: (_d = o['title']) !== null && _d !== void 0 ? _d : '',
        content: (_e = o['content']) !== null && _e !== void 0 ? _e : '',
        contentSize: (_f = o['contentSize']) !== null && _f !== void 0 ? _f : 0,
        contentSizeLimit: (_g = o['contentSizeLimit']) !== null && _g !== void 0 ? _g : 0,
        fileUrl: (_h = o['fileUrl']) !== null && _h !== void 0 ? _h : '',
        sourceNamespace: o['sourceNamespace'] ? namespaceFromJson(o['sourceNamespace']) : undefined,
    };
}
export function chartContentToJson(m) {
    const o = {};
    if (m.apexConfigJson !== undefined)
        o['apexConfigJson'] = m.apexConfigJson;
    return o;
}
export function chartContentFromJson(o) {
    var _a;
    return {
        apexConfigJson: (_a = o['apexConfigJson']) !== null && _a !== void 0 ? _a : '',
    };
}
export function attachmentToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.payload !== undefined) {
        if (m.payload.type === 'image') {
            o['image'] = imageContentToJson(m.payload.image);
        }
        if (m.payload.type === 'chart') {
            o['chart'] = chartContentToJson(m.payload.chart);
        }
    }
    else {
        if (m.image !== undefined)
            o['image'] = imageContentToJson(m.image);
        if (m.chart !== undefined)
            o['chart'] = chartContentToJson(m.chart);
    }
    return o;
}
export function attachmentFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        type: (_b = o['type']) !== null && _b !== void 0 ? _b : 'ATTACHMENT_TYPE_INVALID',
        title: (_c = o['title']) !== null && _c !== void 0 ? _c : '',
        payload: (() => {
            if (o['image'] !== undefined)
                return { type: 'image', image: o['image'] ? imageContentFromJson(o['image']) : undefined };
            if (o['chart'] !== undefined)
                return { type: 'chart', chart: o['chart'] ? chartContentFromJson(o['chart']) : undefined };
            return undefined;
        })(),
        image: o['image'] !== undefined ? o['image'] ? imageContentFromJson(o['image']) : undefined : undefined,
        chart: o['chart'] !== undefined ? o['chart'] ? chartContentFromJson(o['chart']) : undefined : undefined,
    };
}
export function invocationContextToJson(m) {
    const o = {};
    if (m.medium !== undefined)
        o['medium'] = m.medium;
    if (m.channel !== undefined)
        o['channel'] = m.channel;
    if (m.authState !== undefined)
        o['authState'] = m.authState;
    if (m.app !== undefined)
        o['app'] = m.app;
    return o;
}
export function invocationContextFromJson(o) {
    var _a, _b, _c, _d;
    return {
        medium: (_a = o['medium']) !== null && _a !== void 0 ? _a : 'UNSET_MEDIUM',
        channel: (_b = o['channel']) !== null && _b !== void 0 ? _b : 'UNSET_CHANNEL',
        authState: (_c = o['authState']) !== null && _c !== void 0 ? _c : 'UNSET_AUTH_STATE',
        app: (_d = o['app']) !== null && _d !== void 0 ? _d : 'UNSET_APP',
    };
}
export function scopeToJson(m) {
    const o = {};
    if (m.invocationContext !== undefined)
        o['invocationContext'] = invocationContextToJson(m.invocationContext);
    if (m.scope !== undefined) {
        if (m.scope.type === 'assistantNamespaceType') {
            o['assistantNamespaceType'] = m.scope.assistantNamespaceType;
        }
        if (m.scope.type === 'assistantType') {
            o['assistantType'] = m.scope.assistantType;
        }
    }
    else {
        if (m.assistantNamespaceType !== undefined)
            o['assistantNamespaceType'] = m.assistantNamespaceType;
        if (m.assistantType !== undefined)
            o['assistantType'] = m.assistantType;
    }
    return o;
}
export function scopeFromJson(o) {
    return {
        invocationContext: o['invocationContext'] ? invocationContextFromJson(o['invocationContext']) : undefined,
        scope: (() => {
            if (o['assistantNamespaceType'] !== undefined)
                return { type: 'assistantNamespaceType', assistantNamespaceType: o['assistantNamespaceType'] };
            if (o['assistantType'] !== undefined)
                return { type: 'assistantType', assistantType: o['assistantType'] };
            return undefined;
        })(),
        assistantNamespaceType: o['assistantNamespaceType'] !== undefined ? o['assistantNamespaceType'] : undefined,
        assistantType: o['assistantType'] !== undefined ? o['assistantType'] : undefined,
    };
}
export function constraintToJson(m) {
    const o = {};
    if (m.action !== undefined)
        o['action'] = m.action;
    if (m.scope !== undefined)
        o['scope'] = scopeToJson(m.scope);
    if (m.effect !== undefined)
        o['effect'] = m.effect;
    return o;
}
export function constraintFromJson(o) {
    var _a, _b;
    return {
        action: (_a = o['action']) !== null && _a !== void 0 ? _a : 'ACTION_UNSPECIFIED',
        scope: o['scope'] ? scopeFromJson(o['scope']) : undefined,
        effect: (_b = o['effect']) !== null && _b !== void 0 ? _b : 'EFFECT_UNSPECIFIED',
    };
}
export function constraintFilterToJson(m) {
    const o = {};
    if (m.action !== undefined)
        o['action'] = m.action;
    if (m.scope !== undefined)
        o['scope'] = scopeToJson(m.scope);
    return o;
}
export function constraintFilterFromJson(o) {
    var _a;
    return {
        action: (_a = o['action']) !== null && _a !== void 0 ? _a : 'ACTION_UNSPECIFIED',
        scope: o['scope'] ? scopeFromJson(o['scope']) : undefined,
    };
}
export function functionKeyToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function functionKeyFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function functionVersionKeyToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = functionKeyToJson(m.key);
    if (m.version !== undefined)
        o['version'] = m.version;
    if (m.versionNumber !== undefined)
        o['versionNumber'] = m.versionNumber;
    if (m.versionType !== undefined)
        o['versionType'] = m.versionType;
    return o;
}
export function functionVersionKeyFromJson(o) {
    var _a, _b, _c;
    return {
        key: o['key'] ? functionKeyFromJson(o['key']) : undefined,
        version: (_a = o['version']) !== null && _a !== void 0 ? _a : '',
        versionNumber: (_b = o['versionNumber']) !== null && _b !== void 0 ? _b : 0,
        versionType: (_c = o['versionType']) !== null && _c !== void 0 ? _c : 'VERSION_TYPE_INVALID',
    };
}
export function functionParameterToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.properties !== undefined) {
        o['properties'] = m.properties.map(e => functionParameterToJson(e));
    }
    if (m.items !== undefined)
        o['items'] = functionParameterToJson(m.items);
    if (m.value !== undefined)
        o['value'] = m.value;
    if (m.location !== undefined)
        o['location'] = m.location;
    if (m.required !== undefined)
        o['required'] = m.required;
    if (m.enumValues !== undefined) {
        o['enumValues'] = m.enumValues.map(e => e);
    }
    if (m.additionalProperties !== undefined)
        o['additionalProperties'] = functionParameterToJson(m.additionalProperties);
    return o;
}
export function functionParameterFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        description: (_b = o['description']) !== null && _b !== void 0 ? _b : '',
        type: (_c = o['type']) !== null && _c !== void 0 ? _c : '',
        properties: ((_d = o['properties']) !== null && _d !== void 0 ? _d : []).map(e => functionParameterFromJson(e)),
        items: o['items'] ? functionParameterFromJson(o['items']) : undefined,
        value: (_e = o['value']) !== null && _e !== void 0 ? _e : '',
        location: (_f = o['location']) !== null && _f !== void 0 ? _f : 'LOCATION_BODY',
        required: (_g = o['required']) !== null && _g !== void 0 ? _g : false,
        enumValues: ((_h = o['enumValues']) !== null && _h !== void 0 ? _h : []).map(e => e),
        additionalProperties: o['additionalProperties'] ? functionParameterFromJson(o['additionalProperties']) : undefined,
    };
}
export function functionAuthStrategyToJson(m) {
    const o = {};
    if (m.authStrategy !== undefined) {
        if (m.authStrategy.type === 'unspecified') {
            o['unspecified'] = functionAuthStrategyUnspecifiedFunctionAuthStrategyToJson(m.authStrategy.unspecified);
        }
        if (m.authStrategy.type === 'platformManaged') {
            o['platformManaged'] = functionAuthStrategyPlatformManagedFunctionAuthStrategyToJson(m.authStrategy.platformManaged);
        }
        if (m.authStrategy.type === 'connectedIntegration') {
            o['connectedIntegration'] = functionAuthStrategyConnectedIntegrationAuthStrategyToJson(m.authStrategy.connectedIntegration);
        }
        if (m.authStrategy.type === 'impersonation') {
            o['impersonation'] = functionAuthStrategyImpersonationAuthStrategyToJson(m.authStrategy.impersonation);
        }
        if (m.authStrategy.type === 'impersonationWithPlatformManagedFallback') {
            o['impersonationWithPlatformManagedFallback'] = functionAuthStrategyImpersonationWithPlatformManagedFallbackAuthStrategyToJson(m.authStrategy.impersonationWithPlatformManagedFallback);
        }
    }
    else {
        if (m.unspecified !== undefined)
            o['unspecified'] = functionAuthStrategyUnspecifiedFunctionAuthStrategyToJson(m.unspecified);
        if (m.platformManaged !== undefined)
            o['platformManaged'] = functionAuthStrategyPlatformManagedFunctionAuthStrategyToJson(m.platformManaged);
        if (m.connectedIntegration !== undefined)
            o['connectedIntegration'] = functionAuthStrategyConnectedIntegrationAuthStrategyToJson(m.connectedIntegration);
        if (m.impersonation !== undefined)
            o['impersonation'] = functionAuthStrategyImpersonationAuthStrategyToJson(m.impersonation);
        if (m.impersonationWithPlatformManagedFallback !== undefined)
            o['impersonationWithPlatformManagedFallback'] = functionAuthStrategyImpersonationWithPlatformManagedFallbackAuthStrategyToJson(m.impersonationWithPlatformManagedFallback);
    }
    return o;
}
export function functionAuthStrategyFromJson(o) {
    return {
        authStrategy: (() => {
            if (o['unspecified'] !== undefined)
                return { type: 'unspecified', unspecified: o['unspecified'] ? functionAuthStrategyUnspecifiedFunctionAuthStrategyFromJson(o['unspecified']) : undefined };
            if (o['platformManaged'] !== undefined)
                return { type: 'platformManaged', platformManaged: o['platformManaged'] ? functionAuthStrategyPlatformManagedFunctionAuthStrategyFromJson(o['platformManaged']) : undefined };
            if (o['connectedIntegration'] !== undefined)
                return { type: 'connectedIntegration', connectedIntegration: o['connectedIntegration'] ? functionAuthStrategyConnectedIntegrationAuthStrategyFromJson(o['connectedIntegration']) : undefined };
            if (o['impersonation'] !== undefined)
                return { type: 'impersonation', impersonation: o['impersonation'] ? functionAuthStrategyImpersonationAuthStrategyFromJson(o['impersonation']) : undefined };
            if (o['impersonationWithPlatformManagedFallback'] !== undefined)
                return { type: 'impersonationWithPlatformManagedFallback', impersonationWithPlatformManagedFallback: o['impersonationWithPlatformManagedFallback'] ? functionAuthStrategyImpersonationWithPlatformManagedFallbackAuthStrategyFromJson(o['impersonationWithPlatformManagedFallback']) : undefined };
            return undefined;
        })(),
        unspecified: o['unspecified'] !== undefined ? o['unspecified'] ? functionAuthStrategyUnspecifiedFunctionAuthStrategyFromJson(o['unspecified']) : undefined : undefined,
        platformManaged: o['platformManaged'] !== undefined ? o['platformManaged'] ? functionAuthStrategyPlatformManagedFunctionAuthStrategyFromJson(o['platformManaged']) : undefined : undefined,
        connectedIntegration: o['connectedIntegration'] !== undefined ? o['connectedIntegration'] ? functionAuthStrategyConnectedIntegrationAuthStrategyFromJson(o['connectedIntegration']) : undefined : undefined,
        impersonation: o['impersonation'] !== undefined ? o['impersonation'] ? functionAuthStrategyImpersonationAuthStrategyFromJson(o['impersonation']) : undefined : undefined,
        impersonationWithPlatformManagedFallback: o['impersonationWithPlatformManagedFallback'] !== undefined ? o['impersonationWithPlatformManagedFallback'] ? functionAuthStrategyImpersonationWithPlatformManagedFallbackAuthStrategyFromJson(o['impersonationWithPlatformManagedFallback']) : undefined : undefined,
    };
}
export function functionAuthStrategyUnspecifiedFunctionAuthStrategyToJson(m) {
    const o = {};
    return o;
}
export function functionAuthStrategyUnspecifiedFunctionAuthStrategyFromJson(o) {
    return {};
}
export function functionAuthStrategyPlatformManagedFunctionAuthStrategyToJson(m) {
    const o = {};
    if (m.requiredScopes !== undefined) {
        o['requiredScopes'] = m.requiredScopes.map(e => e);
    }
    return o;
}
export function functionAuthStrategyPlatformManagedFunctionAuthStrategyFromJson(o) {
    var _a;
    return {
        requiredScopes: ((_a = o['requiredScopes']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function functionAuthStrategyConnectedIntegrationAuthStrategyToJson(m) {
    const o = {};
    if (m.connectionId !== undefined)
        o['connectionId'] = m.connectionId;
    if (m.integrationType !== undefined)
        o['integrationType'] = m.integrationType;
    return o;
}
export function functionAuthStrategyConnectedIntegrationAuthStrategyFromJson(o) {
    var _a, _b;
    return {
        connectionId: (_a = o['connectionId']) !== null && _a !== void 0 ? _a : '',
        integrationType: (_b = o['integrationType']) !== null && _b !== void 0 ? _b : '',
    };
}
export function functionAuthStrategyImpersonationAuthStrategyToJson(m) {
    const o = {};
    if (m.requiredScopes !== undefined) {
        o['requiredScopes'] = m.requiredScopes.map(e => e);
    }
    return o;
}
export function functionAuthStrategyImpersonationAuthStrategyFromJson(o) {
    var _a;
    return {
        requiredScopes: ((_a = o['requiredScopes']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function functionAuthStrategyImpersonationWithPlatformManagedFallbackAuthStrategyToJson(m) {
    const o = {};
    if (m.requiredScopes !== undefined) {
        o['requiredScopes'] = m.requiredScopes.map(e => e);
    }
    return o;
}
export function functionAuthStrategyImpersonationWithPlatformManagedFallbackAuthStrategyFromJson(o) {
    var _a;
    return {
        requiredScopes: ((_a = o['requiredScopes']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function functionToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.methodType !== undefined)
        o['methodType'] = m.methodType;
    if (m.functionParameters !== undefined) {
        o['functionParameters'] = m.functionParameters.map(e => functionParameterToJson(e));
    }
    if (m.generatesAnswer !== undefined)
        o['generatesAnswer'] = m.generatesAnswer;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => functionHeaderToJson(e));
    }
    if (m.managed !== undefined)
        o['managed'] = m.managed;
    if (m.authStrategy !== undefined)
        o['authStrategy'] = functionAuthStrategyToJson(m.authStrategy);
    if (m.mcpId !== undefined)
        o['mcpId'] = m.mcpId;
    if (m.constraints !== undefined) {
        o['constraints'] = m.constraints.map(e => constraintToJson(e));
    }
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    if (m.noOp !== undefined)
        o['noOp'] = m.noOp;
    if (m.hasCustomHandler !== undefined)
        o['hasCustomHandler'] = m.hasCustomHandler;
    if (m.requiresApproval !== undefined)
        o['requiresApproval'] = m.requiresApproval;
    if (m.responseFieldMask !== undefined)
        o['responseFieldMask'] = fieldMaskToJson(m.responseFieldMask);
    if (m.displayName !== undefined)
        o['displayName'] = m.displayName;
    return o;
}
export function functionFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        description: (_b = o['description']) !== null && _b !== void 0 ? _b : '',
        url: (_c = o['url']) !== null && _c !== void 0 ? _c : '',
        methodType: (_d = o['methodType']) !== null && _d !== void 0 ? _d : '',
        functionParameters: ((_e = o['functionParameters']) !== null && _e !== void 0 ? _e : []).map(e => functionParameterFromJson(e)),
        generatesAnswer: (_f = o['generatesAnswer']) !== null && _f !== void 0 ? _f : false,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        headers: ((_g = o['headers']) !== null && _g !== void 0 ? _g : []).map(e => functionHeaderFromJson(e)),
        managed: (_h = o['managed']) !== null && _h !== void 0 ? _h : false,
        authStrategy: o['authStrategy'] ? functionAuthStrategyFromJson(o['authStrategy']) : undefined,
        mcpId: (_j = o['mcpId']) !== null && _j !== void 0 ? _j : '',
        constraints: ((_k = o['constraints']) !== null && _k !== void 0 ? _k : []).map(e => constraintFromJson(e)),
        sourcePath: (_l = o['sourcePath']) !== null && _l !== void 0 ? _l : '',
        noOp: (_m = o['noOp']) !== null && _m !== void 0 ? _m : false,
        hasCustomHandler: (_o = o['hasCustomHandler']) !== null && _o !== void 0 ? _o : false,
        requiresApproval: (_p = o['requiresApproval']) !== null && _p !== void 0 ? _p : false,
        responseFieldMask: o['responseFieldMask'] ? fieldMaskFromJson(o['responseFieldMask']) : undefined,
        displayName: (_q = o['displayName']) !== null && _q !== void 0 ? _q : '',
    };
}
export function functionHeaderToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    return o;
}
export function functionHeaderFromJson(o) {
    var _a, _b;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listMCPToolsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.authStrategy !== undefined)
        o['authStrategy'] = functionAuthStrategyToJson(m.authStrategy);
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => functionHeaderToJson(e));
    }
    if (m.mcpId !== undefined)
        o['mcpId'] = m.mcpId;
    return o;
}
export function listMCPToolsRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        authStrategy: o['authStrategy'] ? functionAuthStrategyFromJson(o['authStrategy']) : undefined,
        headers: ((_b = o['headers']) !== null && _b !== void 0 ? _b : []).map(e => functionHeaderFromJson(e)),
        mcpId: (_c = o['mcpId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listMCPToolsResponseToJson(m) {
    const o = {};
    if (m.functions !== undefined) {
        o['functions'] = m.functions.map(e => functionToJson(e));
    }
    return o;
}
export function listMCPToolsResponseFromJson(o) {
    var _a;
    return {
        functions: ((_a = o['functions']) !== null && _a !== void 0 ? _a : []).map(e => functionFromJson(e)),
    };
}
export function upsertMCPRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.mcpId !== undefined)
        o['mcpId'] = m.mcpId;
    if (m.functions !== undefined) {
        o['functions'] = m.functions.map(e => functionToJson(e));
    }
    if (m.authStrategy !== undefined)
        o['authStrategy'] = functionAuthStrategyToJson(m.authStrategy);
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => functionHeaderToJson(e));
    }
    if (m.constraints !== undefined) {
        o['constraints'] = m.constraints.map(e => constraintToJson(e));
    }
    return o;
}
export function upsertMCPRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        mcpId: (_b = o['mcpId']) !== null && _b !== void 0 ? _b : '',
        functions: ((_c = o['functions']) !== null && _c !== void 0 ? _c : []).map(e => functionFromJson(e)),
        authStrategy: o['authStrategy'] ? functionAuthStrategyFromJson(o['authStrategy']) : undefined,
        sourcePath: (_d = o['sourcePath']) !== null && _d !== void 0 ? _d : '',
        headers: ((_e = o['headers']) !== null && _e !== void 0 ? _e : []).map(e => functionHeaderFromJson(e)),
        constraints: ((_f = o['constraints']) !== null && _f !== void 0 ? _f : []).map(e => constraintFromJson(e)),
    };
}
export function createMCPFromIntegrationRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.mcpId !== undefined)
        o['mcpId'] = m.mcpId;
    if (m.connectionId !== undefined)
        o['connectionId'] = m.connectionId;
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    return o;
}
export function createMCPFromIntegrationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        mcpId: (_a = o['mcpId']) !== null && _a !== void 0 ? _a : '',
        connectionId: (_b = o['connectionId']) !== null && _b !== void 0 ? _b : '',
        sourcePath: (_c = o['sourcePath']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listMCPsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listMCPsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listMCPsRequestFromJson(o) {
    return {
        filters: o['filters'] ? listMCPsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listMCPsRequestFiltersToJson(m) {
    const o = {};
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => namespaceToJson(e));
    }
    if (m.mcpIds !== undefined) {
        o['mcpIds'] = m.mcpIds.map(e => e);
    }
    return o;
}
export function listMCPsRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => namespaceFromJson(e)),
        mcpIds: ((_b = o['mcpIds']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function mCPToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.authStrategy !== undefined)
        o['authStrategy'] = functionAuthStrategyToJson(m.authStrategy);
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => functionHeaderToJson(e));
    }
    if (m.constraints !== undefined) {
        o['constraints'] = m.constraints.map(e => constraintToJson(e));
    }
    return o;
}
export function mCPFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        url: (_b = o['url']) !== null && _b !== void 0 ? _b : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        authStrategy: o['authStrategy'] ? functionAuthStrategyFromJson(o['authStrategy']) : undefined,
        sourcePath: (_c = o['sourcePath']) !== null && _c !== void 0 ? _c : '',
        headers: ((_d = o['headers']) !== null && _d !== void 0 ? _d : []).map(e => functionHeaderFromJson(e)),
        constraints: ((_e = o['constraints']) !== null && _e !== void 0 ? _e : []).map(e => constraintFromJson(e)),
    };
}
export function listMCPsResponseToJson(m) {
    const o = {};
    if (m.mcps !== undefined) {
        o['mcps'] = m.mcps.map(e => mCPToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listMCPsResponseFromJson(o) {
    var _a;
    return {
        mcps: ((_a = o['mcps']) !== null && _a !== void 0 ? _a : []).map(e => mCPFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function deleteMCPRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.mcpId !== undefined)
        o['mcpId'] = m.mcpId;
    return o;
}
export function deleteMCPRequestFromJson(o) {
    var _a;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        mcpId: (_a = o['mcpId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function validateFunctionsRequestToJson(m) {
    const o = {};
    if (m.functions !== undefined) {
        o['functions'] = m.functions.map(e => functionToJson(e));
    }
    return o;
}
export function validateFunctionsRequestFromJson(o) {
    var _a;
    return {
        functions: ((_a = o['functions']) !== null && _a !== void 0 ? _a : []).map(e => functionFromJson(e)),
    };
}
export function validateFunctionsResponseToJson(m) {
    const o = {};
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => validateFunctionsResponseValidationResultToJson(e));
    }
    if (m.allValid !== undefined)
        o['allValid'] = m.allValid;
    return o;
}
export function validateFunctionsResponseFromJson(o) {
    var _a, _b;
    return {
        results: ((_a = o['results']) !== null && _a !== void 0 ? _a : []).map(e => validateFunctionsResponseValidationResultFromJson(e)),
        allValid: (_b = o['allValid']) !== null && _b !== void 0 ? _b : false,
    };
}
export function validateFunctionsResponseValidationResultToJson(m) {
    const o = {};
    if (m.functionId !== undefined)
        o['functionId'] = m.functionId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function validateFunctionsResponseValidationResultFromJson(o) {
    var _a, _b, _c;
    return {
        functionId: (_a = o['functionId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        isValid: (_b = o['isValid']) !== null && _b !== void 0 ? _b : false,
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function validateMCPsRequestToJson(m) {
    const o = {};
    if (m.mcps !== undefined) {
        o['mcps'] = m.mcps.map(e => mCPToJson(e));
    }
    return o;
}
export function validateMCPsRequestFromJson(o) {
    var _a;
    return {
        mcps: ((_a = o['mcps']) !== null && _a !== void 0 ? _a : []).map(e => mCPFromJson(e)),
    };
}
export function validateMCPsResponseToJson(m) {
    const o = {};
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => validateMCPsResponseValidationResultToJson(e));
    }
    if (m.allValid !== undefined)
        o['allValid'] = m.allValid;
    return o;
}
export function validateMCPsResponseFromJson(o) {
    var _a, _b;
    return {
        results: ((_a = o['results']) !== null && _a !== void 0 ? _a : []).map(e => validateMCPsResponseValidationResultFromJson(e)),
        allValid: (_b = o['allValid']) !== null && _b !== void 0 ? _b : false,
    };
}
export function validateMCPsResponseValidationResultToJson(m) {
    const o = {};
    if (m.mcpId !== undefined)
        o['mcpId'] = m.mcpId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function validateMCPsResponseValidationResultFromJson(o) {
    var _a, _b, _c;
    return {
        mcpId: (_a = o['mcpId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        isValid: (_b = o['isValid']) !== null && _b !== void 0 ? _b : false,
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function serializeFunctionRequestToJson(m) {
    const o = {};
    if (m.function !== undefined)
        o['function'] = functionToJson(m.function);
    return o;
}
export function serializeFunctionRequestFromJson(o) {
    return {
        function: o['function'] ? functionFromJson(o['function']) : undefined,
    };
}
export function serializeFunctionResponseToJson(m) {
    const o = {};
    if (m.file !== undefined)
        o['file'] = m.file;
    return o;
}
export function serializeFunctionResponseFromJson(o) {
    var _a;
    return {
        file: (_a = o['file']) !== null && _a !== void 0 ? _a : '',
    };
}
export function serializeMCPRequestToJson(m) {
    const o = {};
    if (m.mcp !== undefined)
        o['mcp'] = mCPToJson(m.mcp);
    return o;
}
export function serializeMCPRequestFromJson(o) {
    return {
        mcp: o['mcp'] ? mCPFromJson(o['mcp']) : undefined,
    };
}
export function serializeMCPResponseToJson(m) {
    const o = {};
    if (m.file !== undefined)
        o['file'] = m.file;
    return o;
}
export function serializeMCPResponseFromJson(o) {
    var _a;
    return {
        file: (_a = o['file']) !== null && _a !== void 0 ? _a : '',
    };
}
export function promptModuleKeyToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function promptModuleKeyFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function promptModuleVersionKeyToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = promptModuleKeyToJson(m.key);
    if (m.version !== undefined)
        o['version'] = m.version;
    if (m.versionType !== undefined)
        o['versionType'] = m.versionType;
    return o;
}
export function promptModuleVersionKeyFromJson(o) {
    var _a, _b;
    return {
        key: o['key'] ? promptModuleKeyFromJson(o['key']) : undefined,
        version: (_a = o['version']) !== null && _a !== void 0 ? _a : '',
        versionType: (_b = o['versionType']) !== null && _b !== void 0 ? _b : 'VERSION_TYPE_INVALID',
    };
}
export function promptModuleToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.deployedVersion !== undefined)
        o['deployedVersion'] = m.deployedVersion;
    if (m.deployedBy !== undefined)
        o['deployedBy'] = m.deployedBy;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.deployed !== undefined)
        o['deployed'] = m.deployed.toISOString();
    if (m.managed !== undefined)
        o['managed'] = m.managed;
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function promptModuleFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        deployedVersion: (_d = o['deployedVersion']) !== null && _d !== void 0 ? _d : '',
        deployedBy: (_e = o['deployedBy']) !== null && _e !== void 0 ? _e : '',
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        deployed: o['deployed'] ? new Date(o['deployed']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        managed: (_f = o['managed']) !== null && _f !== void 0 ? _f : false,
        sourcePath: (_g = o['sourcePath']) !== null && _g !== void 0 ? _g : '',
        content: (_h = o['content']) !== null && _h !== void 0 ? _h : '',
    };
}
export function promptModuleVersionToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.version !== undefined)
        o['version'] = m.version;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.createdBy !== undefined)
        o['createdBy'] = m.createdBy;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    return o;
}
export function promptModuleVersionFromJson(o) {
    var _a, _b, _c, _d;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        version: (_b = o['version']) !== null && _b !== void 0 ? _b : '',
        content: (_c = o['content']) !== null && _c !== void 0 ? _c : '',
        createdBy: (_d = o['createdBy']) !== null && _d !== void 0 ? _d : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function serializePromptModuleRequestToJson(m) {
    const o = {};
    if (m.promptModule !== undefined)
        o['promptModule'] = promptModuleToJson(m.promptModule);
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function serializePromptModuleRequestFromJson(o) {
    var _a;
    return {
        promptModule: o['promptModule'] ? promptModuleFromJson(o['promptModule']) : undefined,
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
    };
}
export function serializePromptModuleResponseToJson(m) {
    const o = {};
    if (m.promptModuleFile !== undefined)
        o['promptModuleFile'] = m.promptModuleFile;
    if (m.contentFile !== undefined)
        o['contentFile'] = m.contentFile;
    return o;
}
export function serializePromptModuleResponseFromJson(o) {
    var _a, _b;
    return {
        promptModuleFile: (_a = o['promptModuleFile']) !== null && _a !== void 0 ? _a : '',
        contentFile: (_b = o['contentFile']) !== null && _b !== void 0 ? _b : '',
    };
}
export function goalKeyToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function goalKeyFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function goalVersionKeyToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = goalKeyToJson(m.key);
    if (m.version !== undefined)
        o['version'] = m.version;
    if (m.versionNumber !== undefined)
        o['versionNumber'] = m.versionNumber;
    if (m.versionType !== undefined)
        o['versionType'] = m.versionType;
    return o;
}
export function goalVersionKeyFromJson(o) {
    var _a, _b, _c;
    return {
        key: o['key'] ? goalKeyFromJson(o['key']) : undefined,
        version: (_a = o['version']) !== null && _a !== void 0 ? _a : '',
        versionNumber: (_b = o['versionNumber']) !== null && _b !== void 0 ? _b : 0,
        versionType: (_c = o['versionType']) !== null && _c !== void 0 ? _c : 'VERSION_TYPE_INVALID',
    };
}
export function goalToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.promptModules !== undefined) {
        o['promptModules'] = m.promptModules.map(e => promptModuleToJson(e));
    }
    if (m.functions !== undefined) {
        o['functions'] = m.functions.map(e => functionToJson(e));
    }
    if (m.updatedBy !== undefined)
        o['updatedBy'] = m.updatedBy;
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.supportedChannels !== undefined) {
        o['supportedChannels'] = m.supportedChannels.map(e => e);
    }
    if (m.managed !== undefined)
        o['managed'] = m.managed;
    if (m.overrideOf !== undefined)
        o['overrideOf'] = goalKeyToJson(m.overrideOf);
    if (m.constraints !== undefined) {
        o['constraints'] = m.constraints.map(e => constraintToJson(e));
    }
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    if (m.agentRole !== undefined)
        o['agentRole'] = m.agentRole;
    if (m.version !== undefined)
        o['version'] = m.version;
    if (m.versionNumber !== undefined)
        o['versionNumber'] = m.versionNumber;
    return o;
}
export function goalFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        type: (_d = o['type']) !== null && _d !== void 0 ? _d : 'GOAL_TYPE_INVALID',
        promptModules: ((_e = o['promptModules']) !== null && _e !== void 0 ? _e : []).map(e => promptModuleFromJson(e)),
        functions: ((_f = o['functions']) !== null && _f !== void 0 ? _f : []).map(e => functionFromJson(e)),
        updatedBy: (_g = o['updatedBy']) !== null && _g !== void 0 ? _g : '',
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        supportedChannels: ((_h = o['supportedChannels']) !== null && _h !== void 0 ? _h : []).map(e => e),
        managed: (_j = o['managed']) !== null && _j !== void 0 ? _j : false,
        overrideOf: o['overrideOf'] ? goalKeyFromJson(o['overrideOf']) : undefined,
        constraints: ((_k = o['constraints']) !== null && _k !== void 0 ? _k : []).map(e => constraintFromJson(e)),
        sourcePath: (_l = o['sourcePath']) !== null && _l !== void 0 ? _l : '',
        agentRole: (_m = o['agentRole']) !== null && _m !== void 0 ? _m : 'AGENT_ROLE_UNSPECIFIED',
        version: (_o = o['version']) !== null && _o !== void 0 ? _o : '',
        versionNumber: (_p = o['versionNumber']) !== null && _p !== void 0 ? _p : 0,
    };
}
export function validateGoalsRequestToJson(m) {
    const o = {};
    if (m.goals !== undefined) {
        o['goals'] = m.goals.map(e => goalToJson(e));
    }
    return o;
}
export function validateGoalsRequestFromJson(o) {
    var _a;
    return {
        goals: ((_a = o['goals']) !== null && _a !== void 0 ? _a : []).map(e => goalFromJson(e)),
    };
}
export function validateGoalsResponseToJson(m) {
    const o = {};
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => validateGoalsResponseValidationResultToJson(e));
    }
    if (m.allValid !== undefined)
        o['allValid'] = m.allValid;
    return o;
}
export function validateGoalsResponseFromJson(o) {
    var _a, _b;
    return {
        results: ((_a = o['results']) !== null && _a !== void 0 ? _a : []).map(e => validateGoalsResponseValidationResultFromJson(e)),
        allValid: (_b = o['allValid']) !== null && _b !== void 0 ? _b : false,
    };
}
export function validateGoalsResponseValidationResultToJson(m) {
    const o = {};
    if (m.goalId !== undefined)
        o['goalId'] = m.goalId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function validateGoalsResponseValidationResultFromJson(o) {
    var _a, _b, _c;
    return {
        goalId: (_a = o['goalId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        isValid: (_b = o['isValid']) !== null && _b !== void 0 ? _b : false,
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function serializeGoalRequestToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    return o;
}
export function serializeGoalRequestFromJson(o) {
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
    };
}
export function serializeGoalResponseToJson(m) {
    const o = {};
    if (m.file !== undefined)
        o['file'] = m.file;
    return o;
}
export function serializeGoalResponseFromJson(o) {
    var _a;
    return {
        file: (_a = o['file']) !== null && _a !== void 0 ? _a : '',
    };
}
export function modelToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.vendor !== undefined)
        o['vendor'] = m.vendor;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.recommended !== undefined)
        o['recommended'] = m.recommended;
    if (m.supportedReasoningEfforts !== undefined) {
        o['supportedReasoningEfforts'] = m.supportedReasoningEfforts.map(e => e);
    }
    return o;
}
export function modelFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        vendor: (_b = o['vendor']) !== null && _b !== void 0 ? _b : 'VENDOR_UNSET',
        type: (_c = o['type']) !== null && _c !== void 0 ? _c : 'TYPE_UNSET',
        name: (_d = o['name']) !== null && _d !== void 0 ? _d : '',
        recommended: (_e = o['recommended']) !== null && _e !== void 0 ? _e : false,
        supportedReasoningEfforts: ((_f = o['supportedReasoningEfforts']) !== null && _f !== void 0 ? _f : []).map(e => e),
    };
}
export function openAIRealtimeConfigToJson(m) {
    const o = {};
    if (m.voice !== undefined)
        o['voice'] = m.voice;
    if (m.turnDetection !== undefined)
        o['turnDetection'] = openAIRealtimeConfigTurnDetectionToJson(m.turnDetection);
    return o;
}
export function openAIRealtimeConfigFromJson(o) {
    var _a;
    return {
        voice: (_a = o['voice']) !== null && _a !== void 0 ? _a : '',
        turnDetection: o['turnDetection'] ? openAIRealtimeConfigTurnDetectionFromJson(o['turnDetection']) : undefined,
    };
}
export function openAIRealtimeConfigTurnDetectionToJson(m) {
    const o = {};
    if (m.threshold !== undefined)
        o['threshold'] = m.threshold;
    if (m.prefixPadding !== undefined)
        o['prefixPadding'] = m.prefixPadding;
    if (m.silenceDuration !== undefined)
        o['silenceDuration'] = m.silenceDuration;
    if (m.vadType !== undefined)
        o['vadType'] = m.vadType;
    if (m.eagerness !== undefined)
        o['eagerness'] = m.eagerness;
    return o;
}
export function openAIRealtimeConfigTurnDetectionFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        threshold: (_a = o['threshold']) !== null && _a !== void 0 ? _a : 0,
        prefixPadding: (_b = o['prefixPadding']) !== null && _b !== void 0 ? _b : 0,
        silenceDuration: (_c = o['silenceDuration']) !== null && _c !== void 0 ? _c : 0,
        vadType: (_d = o['vadType']) !== null && _d !== void 0 ? _d : 'VAD_TYPE_UNSPECIFIED',
        eagerness: (_e = o['eagerness']) !== null && _e !== void 0 ? _e : 'VAD_EAGERNESS_LOW',
    };
}
export function openAIConfigToJson(m) {
    const o = {};
    if (m.voice !== undefined)
        o['voice'] = m.voice;
    return o;
}
export function openAIConfigFromJson(o) {
    var _a;
    return {
        voice: (_a = o['voice']) !== null && _a !== void 0 ? _a : '',
    };
}
export function deepgramConfigToJson(m) {
    const o = {};
    if (m.voice !== undefined)
        o['voice'] = m.voice;
    return o;
}
export function deepgramConfigFromJson(o) {
    var _a;
    return {
        voice: (_a = o['voice']) !== null && _a !== void 0 ? _a : '',
    };
}
export function elevenLabsConfigToJson(m) {
    const o = {};
    if (m.voice !== undefined)
        o['voice'] = m.voice;
    return o;
}
export function elevenLabsConfigFromJson(o) {
    var _a;
    return {
        voice: (_a = o['voice']) !== null && _a !== void 0 ? _a : '',
    };
}
export function modelConfigToJson(m) {
    const o = {};
    if (m.openaiRealtimeConfig !== undefined)
        o['openaiRealtimeConfig'] = openAIRealtimeConfigToJson(m.openaiRealtimeConfig);
    if (m.deepgramConfig !== undefined)
        o['deepgramConfig'] = deepgramConfigToJson(m.deepgramConfig);
    if (m.elevenLabsConfig !== undefined)
        o['elevenLabsConfig'] = elevenLabsConfigToJson(m.elevenLabsConfig);
    if (m.openaiConfig !== undefined)
        o['openaiConfig'] = openAIConfigToJson(m.openaiConfig);
    return o;
}
export function modelConfigFromJson(o) {
    return {
        openaiRealtimeConfig: o['openaiRealtimeConfig'] ? openAIRealtimeConfigFromJson(o['openaiRealtimeConfig']) : undefined,
        deepgramConfig: o['deepgramConfig'] ? deepgramConfigFromJson(o['deepgramConfig']) : undefined,
        elevenLabsConfig: o['elevenLabsConfig'] ? elevenLabsConfigFromJson(o['elevenLabsConfig']) : undefined,
        openaiConfig: o['openaiConfig'] ? openAIConfigFromJson(o['openaiConfig']) : undefined,
    };
}
export function configToJson(m) {
    const o = {};
    if (m.inboxConfig !== undefined)
        o['inboxConfig'] = configInboxConfigToJson(m.inboxConfig);
    if (m.voiceConfig !== undefined)
        o['voiceConfig'] = configVoiceConfigToJson(m.voiceConfig);
    if (m.models !== undefined) {
        o['models'] = m.models.map(e => modelToJson(e));
    }
    if (m.situationConfig !== undefined)
        o['situationConfig'] = situationConfigToJson(m.situationConfig);
    return o;
}
export function configFromJson(o) {
    var _a;
    return {
        inboxConfig: o['inboxConfig'] ? configInboxConfigFromJson(o['inboxConfig']) : undefined,
        voiceConfig: o['voiceConfig'] ? configVoiceConfigFromJson(o['voiceConfig']) : undefined,
        models: ((_a = o['models']) !== null && _a !== void 0 ? _a : []).map(e => modelFromJson(e)),
        situationConfig: o['situationConfig'] ? situationConfigFromJson(o['situationConfig']) : undefined,
    };
}
export function configInboxConfigToJson(m) {
    const o = {};
    if (m.leadCaptureEnabled !== undefined)
        o['leadCaptureEnabled'] = m.leadCaptureEnabled;
    if (m.additionalInstructions !== undefined)
        o['additionalInstructions'] = m.additionalInstructions;
    return o;
}
export function configInboxConfigFromJson(o) {
    var _a, _b;
    return {
        leadCaptureEnabled: (_a = o['leadCaptureEnabled']) !== null && _a !== void 0 ? _a : false,
        additionalInstructions: (_b = o['additionalInstructions']) !== null && _b !== void 0 ? _b : '',
    };
}
export function configVoiceConfigToJson(m) {
    const o = {};
    if (m.vendorModel !== undefined)
        o['vendorModel'] = m.vendorModel;
    if (m.modelConfig !== undefined)
        o['modelConfig'] = modelConfigToJson(m.modelConfig);
    if (m.preGreetingMessage !== undefined)
        o['preGreetingMessage'] = m.preGreetingMessage;
    return o;
}
export function configVoiceConfigFromJson(o) {
    var _a, _b;
    return {
        vendorModel: (_a = o['vendorModel']) !== null && _a !== void 0 ? _a : 'VENDOR_MODEL_UNSPECIFIED',
        modelConfig: o['modelConfig'] ? modelConfigFromJson(o['modelConfig']) : undefined,
        preGreetingMessage: (_b = o['preGreetingMessage']) !== null && _b !== void 0 ? _b : '',
    };
}
export function assistantKeyToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function assistantKeyFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function assistantVersionKeyToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = assistantKeyToJson(m.key);
    if (m.version !== undefined)
        o['version'] = m.version;
    if (m.versionNumber !== undefined)
        o['versionNumber'] = m.versionNumber;
    if (m.versionType !== undefined)
        o['versionType'] = m.versionType;
    return o;
}
export function assistantVersionKeyFromJson(o) {
    var _a, _b, _c;
    return {
        key: o['key'] ? assistantKeyFromJson(o['key']) : undefined,
        version: (_a = o['version']) !== null && _a !== void 0 ? _a : '',
        versionNumber: (_b = o['versionNumber']) !== null && _b !== void 0 ? _b : 0,
        versionType: (_c = o['versionType']) !== null && _c !== void 0 ? _c : 'VERSION_TYPE_INVALID',
    };
}
export function assistantVersionSummaryToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = assistantVersionKeyToJson(m.key);
    if (m.versionMessage !== undefined)
        o['versionMessage'] = m.versionMessage;
    if (m.createdBy !== undefined)
        o['createdBy'] = m.createdBy;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.name !== undefined)
        o['name'] = m.name;
    return o;
}
export function assistantVersionSummaryFromJson(o) {
    var _a, _b, _c;
    return {
        key: o['key'] ? assistantVersionKeyFromJson(o['key']) : undefined,
        versionMessage: (_a = o['versionMessage']) !== null && _a !== void 0 ? _a : '',
        createdBy: (_b = o['createdBy']) !== null && _b !== void 0 ? _b : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        name: (_c = o['name']) !== null && _c !== void 0 ? _c : '',
    };
}
export function configurableGoalToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    if (m.configuration !== undefined) {
        o['configuration'] = m.configuration.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function configurableGoalFromJson(o) {
    var _a;
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
        configuration: ((_a = o['configuration']) !== null && _a !== void 0 ? _a : []).map(e => keyValuePairFromJson(e)),
    };
}
export function validatorToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.config !== undefined)
        o['config'] = m.config;
    return o;
}
export function validatorFromJson(o) {
    var _a, _b;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        config: (_b = o['config']) !== null && _b !== void 0 ? _b : {},
    };
}
export function situationMappingToJson(m) {
    const o = {};
    if (m.situation !== undefined)
        o['situation'] = m.situation;
    if (m.goalKeys !== undefined) {
        o['goalKeys'] = m.goalKeys.map(e => goalKeyToJson(e));
    }
    return o;
}
export function situationMappingFromJson(o) {
    var _a, _b;
    return {
        situation: (_a = o['situation']) !== null && _a !== void 0 ? _a : '',
        goalKeys: ((_b = o['goalKeys']) !== null && _b !== void 0 ? _b : []).map(e => goalKeyFromJson(e)),
    };
}
export function situationConfigToJson(m) {
    const o = {};
    if (m.simpleConfig !== undefined) {
        o['simpleConfig'] = m.simpleConfig.map(e => situationMappingToJson(e));
    }
    if (m.customConfig !== undefined)
        o['customConfig'] = m.customConfig;
    if (m.useCustomConfig !== undefined)
        o['useCustomConfig'] = m.useCustomConfig;
    return o;
}
export function situationConfigFromJson(o) {
    var _a, _b, _c;
    return {
        simpleConfig: ((_a = o['simpleConfig']) !== null && _a !== void 0 ? _a : []).map(e => situationMappingFromJson(e)),
        customConfig: (_b = o['customConfig']) !== null && _b !== void 0 ? _b : '',
        useCustomConfig: (_c = o['useCustomConfig']) !== null && _c !== void 0 ? _c : false,
    };
}
export function automationBlueprintToJson(m) {
    const o = {};
    if (m.templateId !== undefined)
        o['templateId'] = m.templateId;
    return o;
}
export function automationBlueprintFromJson(o) {
    var _a;
    return {
        templateId: (_a = o['templateId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function assistantToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.avatarUrl !== undefined)
        o['avatarUrl'] = m.avatarUrl;
    if (m.config !== undefined)
        o['config'] = configToJson(m.config);
    if (m.configurableGoals !== undefined) {
        o['configurableGoals'] = m.configurableGoals.map(e => configurableGoalToJson(e));
    }
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.role !== undefined)
        o['role'] = m.role;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.inputValidators !== undefined) {
        o['inputValidators'] = m.inputValidators.map(e => validatorToJson(e));
    }
    if (m.outputValidators !== undefined) {
        o['outputValidators'] = m.outputValidators.map(e => validatorToJson(e));
    }
    if (m.automationBlueprints !== undefined) {
        o['automationBlueprints'] = m.automationBlueprints.map(e => automationBlueprintToJson(e));
    }
    if (m.version !== undefined)
        o['version'] = m.version;
    if (m.versionNumber !== undefined)
        o['versionNumber'] = m.versionNumber;
    return o;
}
export function assistantFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        type: (_c = o['type']) !== null && _c !== void 0 ? _c : 'ASSISTANT_TYPE_UNSPECIFIED',
        avatarUrl: (_d = o['avatarUrl']) !== null && _d !== void 0 ? _d : '',
        config: o['config'] ? configFromJson(o['config']) : undefined,
        configurableGoals: ((_e = o['configurableGoals']) !== null && _e !== void 0 ? _e : []).map(e => configurableGoalFromJson(e)),
        userId: (_f = o['userId']) !== null && _f !== void 0 ? _f : '',
        role: (_g = o['role']) !== null && _g !== void 0 ? _g : '',
        description: (_h = o['description']) !== null && _h !== void 0 ? _h : '',
        inputValidators: ((_j = o['inputValidators']) !== null && _j !== void 0 ? _j : []).map(e => validatorFromJson(e)),
        outputValidators: ((_k = o['outputValidators']) !== null && _k !== void 0 ? _k : []).map(e => validatorFromJson(e)),
        automationBlueprints: ((_l = o['automationBlueprints']) !== null && _l !== void 0 ? _l : []).map(e => automationBlueprintFromJson(e)),
        version: (_m = o['version']) !== null && _m !== void 0 ? _m : '',
        versionNumber: (_o = o['versionNumber']) !== null && _o !== void 0 ? _o : 0,
    };
}
export function templateVariableToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = m.key;
    if (m.value !== undefined)
        o['value'] = m.value;
    if (m.description !== undefined)
        o['description'] = m.description;
    return o;
}
export function templateVariableFromJson(o) {
    var _a, _b, _c;
    return {
        key: (_a = o['key']) !== null && _a !== void 0 ? _a : '',
        value: (_b = o['value']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
    };
}
export function assistantTypeStatusToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.status !== undefined)
        o['status'] = m.status;
    return o;
}
export function assistantTypeStatusFromJson(o) {
    var _a, _b;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'ASSISTANT_TYPE_UNSPECIFIED',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : 'STATUS_INVALID',
    };
}
export function getAssistantTypeStatusRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getAssistantTypeStatusRequestFromJson(o) {
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getAssistantTypeStatusResponseToJson(m) {
    const o = {};
    if (m.statuses !== undefined) {
        o['statuses'] = m.statuses.map(e => assistantTypeStatusToJson(e));
    }
    if (m.canManageAssistants !== undefined)
        o['canManageAssistants'] = m.canManageAssistants;
    return o;
}
export function getAssistantTypeStatusResponseFromJson(o) {
    var _a, _b;
    return {
        statuses: ((_a = o['statuses']) !== null && _a !== void 0 ? _a : []).map(e => assistantTypeStatusFromJson(e)),
        canManageAssistants: (_b = o['canManageAssistants']) !== null && _b !== void 0 ? _b : false,
    };
}
export function connectionKeyToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.connectionType !== undefined)
        o['connectionType'] = m.connectionType;
    return o;
}
export function connectionKeyFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        connectionType: (_b = o['connectionType']) !== null && _b !== void 0 ? _b : '',
    };
}
export function connectionToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.configurationUrl !== undefined)
        o['configurationUrl'] = m.configurationUrl;
    if (m.assistantKeys !== undefined) {
        o['assistantKeys'] = m.assistantKeys.map(e => assistantKeyToJson(e));
    }
    if (m.connectionType !== undefined)
        o['connectionType'] = m.connectionType;
    if (m.connectionTypeName !== undefined)
        o['connectionTypeName'] = m.connectionTypeName;
    if (m.iconUrl !== undefined)
        o['iconUrl'] = m.iconUrl;
    if (m.isConnectionLocked !== undefined)
        o['isConnectionLocked'] = m.isConnectionLocked;
    if (m.supportedAssistantTypes !== undefined) {
        o['supportedAssistantTypes'] = m.supportedAssistantTypes.map(e => e);
    }
    if (m.allowMultipleAssistants !== undefined)
        o['allowMultipleAssistants'] = m.allowMultipleAssistants;
    return o;
}
export function connectionFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        configurationUrl: (_c = o['configurationUrl']) !== null && _c !== void 0 ? _c : '',
        assistantKeys: ((_d = o['assistantKeys']) !== null && _d !== void 0 ? _d : []).map(e => assistantKeyFromJson(e)),
        connectionType: (_e = o['connectionType']) !== null && _e !== void 0 ? _e : '',
        connectionTypeName: (_f = o['connectionTypeName']) !== null && _f !== void 0 ? _f : '',
        iconUrl: (_g = o['iconUrl']) !== null && _g !== void 0 ? _g : '',
        isConnectionLocked: (_h = o['isConnectionLocked']) !== null && _h !== void 0 ? _h : false,
        supportedAssistantTypes: ((_j = o['supportedAssistantTypes']) !== null && _j !== void 0 ? _j : []).map(e => e),
        allowMultipleAssistants: (_k = o['allowMultipleAssistants']) !== null && _k !== void 0 ? _k : false,
    };
}
export function sortOptionsToJson(m) {
    const o = {};
    if (m.direction !== undefined)
        o['direction'] = m.direction;
    if (m.field !== undefined)
        o['field'] = m.field;
    return o;
}
export function sortOptionsFromJson(o) {
    var _a, _b;
    return {
        direction: (_a = o['direction']) !== null && _a !== void 0 ? _a : 'SORT_DIRECTION_INVALID',
        field: (_b = o['field']) !== null && _b !== void 0 ? _b : '',
    };
}
export function testCaseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.chatHistory !== undefined) {
        o['chatHistory'] = m.chatHistory.map(e => chatMessageToJson(e));
    }
    if (m.expectation !== undefined)
        o['expectation'] = m.expectation;
    if (m.expectedToolCalls !== undefined) {
        o['expectedToolCalls'] = m.expectedToolCalls.map(e => expectedToolCallToJson(e));
    }
    if (m.agentArchitecture !== undefined)
        o['agentArchitecture'] = m.agentArchitecture;
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    if (m.testType !== undefined)
        o['testType'] = m.testType;
    if (m.callerInstructions !== undefined)
        o['callerInstructions'] = m.callerInstructions;
    if (m.expectedCitations !== undefined) {
        o['expectedCitations'] = m.expectedCitations.map(e => expectedCitationToJson(e));
    }
    if (m.isSuccessEvaluator !== undefined)
        o['isSuccessEvaluator'] = m.isSuccessEvaluator;
    if (m.scenario !== undefined)
        o['scenario'] = m.scenario;
    if (m.invocationContext !== undefined)
        o['invocationContext'] = invocationContextToJson(m.invocationContext);
    if (m.constraints !== undefined) {
        o['constraints'] = m.constraints.map(e => constraintToJson(e));
    }
    return o;
}
export function testCaseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        chatHistory: ((_c = o['chatHistory']) !== null && _c !== void 0 ? _c : []).map(e => chatMessageFromJson(e)),
        expectation: (_d = o['expectation']) !== null && _d !== void 0 ? _d : '',
        expectedToolCalls: ((_e = o['expectedToolCalls']) !== null && _e !== void 0 ? _e : []).map(e => expectedToolCallFromJson(e)),
        agentArchitecture: (_f = o['agentArchitecture']) !== null && _f !== void 0 ? _f : 'UNSET',
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
        testType: (_g = o['testType']) !== null && _g !== void 0 ? _g : 'TEST_TYPE_UNSPECIFIED',
        callerInstructions: (_h = o['callerInstructions']) !== null && _h !== void 0 ? _h : '',
        expectedCitations: ((_j = o['expectedCitations']) !== null && _j !== void 0 ? _j : []).map(e => expectedCitationFromJson(e)),
        isSuccessEvaluator: (_k = o['isSuccessEvaluator']) !== null && _k !== void 0 ? _k : false,
        scenario: (_l = o['scenario']) !== null && _l !== void 0 ? _l : '',
        invocationContext: o['invocationContext'] ? invocationContextFromJson(o['invocationContext']) : undefined,
        constraints: ((_m = o['constraints']) !== null && _m !== void 0 ? _m : []).map(e => constraintFromJson(e)),
    };
}
export function testCaseKeyToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function testCaseKeyFromJson(o) {
    var _a;
    return {
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function scheduleConfigToJson(m) {
    const o = {};
    if (m.tier !== undefined)
        o['tier'] = m.tier;
    if (m.consecutiveFailureThreshold !== undefined)
        o['consecutiveFailureThreshold'] = m.consecutiveFailureThreshold;
    if (m.notificationGchatWebhookUrl !== undefined)
        o['notificationGchatWebhookUrl'] = m.notificationGchatWebhookUrl;
    if (m.nextRunAt !== undefined)
        o['nextRunAt'] = m.nextRunAt.toISOString();
    return o;
}
export function scheduleConfigFromJson(o) {
    var _a, _b, _c;
    return {
        tier: (_a = o['tier']) !== null && _a !== void 0 ? _a : 'SCHEDULE_TIER_UNSPECIFIED',
        consecutiveFailureThreshold: (_b = o['consecutiveFailureThreshold']) !== null && _b !== void 0 ? _b : 0,
        notificationGchatWebhookUrl: (_c = o['notificationGchatWebhookUrl']) !== null && _c !== void 0 ? _c : '',
        nextRunAt: o['nextRunAt'] ? new Date(o['nextRunAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
    };
}
export function testSuiteToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.testCaseKeys !== undefined) {
        o['testCaseKeys'] = m.testCaseKeys.map(e => testCaseKeyToJson(e));
    }
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    if (m.schedule !== undefined)
        o['schedule'] = scheduleConfigToJson(m.schedule);
    if (m.failureThresholdPercentage !== undefined)
        o['failureThresholdPercentage'] = m.failureThresholdPercentage;
    return o;
}
export function testSuiteFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        testCaseKeys: ((_c = o['testCaseKeys']) !== null && _c !== void 0 ? _c : []).map(e => testCaseKeyFromJson(e)),
        description: (_d = o['description']) !== null && _d !== void 0 ? _d : '',
        tags: ((_e = o['tags']) !== null && _e !== void 0 ? _e : []).map(e => e),
        schedule: o['schedule'] ? scheduleConfigFromJson(o['schedule']) : undefined,
        failureThresholdPercentage: (_f = o['failureThresholdPercentage']) !== null && _f !== void 0 ? _f : 0,
    };
}
export function listTestCasesByAssistantRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.sortOptions !== undefined)
        o['sortOptions'] = sortOptionsToJson(m.sortOptions);
    if (m.onlyEvaluators !== undefined)
        o['onlyEvaluators'] = m.onlyEvaluators;
    return o;
}
export function listTestCasesByAssistantRequestFromJson(o) {
    var _a, _b;
    return {
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
        sortOptions: o['sortOptions'] ? sortOptionsFromJson(o['sortOptions']) : undefined,
        onlyEvaluators: (_b = o['onlyEvaluators']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listTestCasesByAssistantResponseToJson(m) {
    const o = {};
    if (m.testCases !== undefined) {
        o['testCases'] = m.testCases.map(e => testCaseToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listTestCasesByAssistantResponseFromJson(o) {
    var _a;
    return {
        testCases: ((_a = o['testCases']) !== null && _a !== void 0 ? _a : []).map(e => testCaseFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function upsertTestCasesRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    if (m.testCases !== undefined) {
        o['testCases'] = m.testCases.map(e => testCaseToJson(e));
    }
    return o;
}
export function upsertTestCasesRequestFromJson(o) {
    var _a;
    return {
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
        testCases: ((_a = o['testCases']) !== null && _a !== void 0 ? _a : []).map(e => testCaseFromJson(e)),
    };
}
export function deleteTestCasesRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    if (m.testCaseIds !== undefined) {
        o['testCaseIds'] = m.testCaseIds.map(e => e);
    }
    return o;
}
export function deleteTestCasesRequestFromJson(o) {
    var _a;
    return {
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
        testCaseIds: ((_a = o['testCaseIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function validateTestCasesRequestToJson(m) {
    const o = {};
    if (m.testCases !== undefined) {
        o['testCases'] = m.testCases.map(e => testCaseToJson(e));
    }
    return o;
}
export function validateTestCasesRequestFromJson(o) {
    var _a;
    return {
        testCases: ((_a = o['testCases']) !== null && _a !== void 0 ? _a : []).map(e => testCaseFromJson(e)),
    };
}
export function validateTestCasesResponseToJson(m) {
    const o = {};
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => validateTestCasesResponseValidationResultToJson(e));
    }
    if (m.allValid !== undefined)
        o['allValid'] = m.allValid;
    return o;
}
export function validateTestCasesResponseFromJson(o) {
    var _a, _b;
    return {
        results: ((_a = o['results']) !== null && _a !== void 0 ? _a : []).map(e => validateTestCasesResponseValidationResultFromJson(e)),
        allValid: (_b = o['allValid']) !== null && _b !== void 0 ? _b : false,
    };
}
export function validateTestCasesResponseValidationResultToJson(m) {
    const o = {};
    if (m.testCaseId !== undefined)
        o['testCaseId'] = m.testCaseId;
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function validateTestCasesResponseValidationResultFromJson(o) {
    var _a, _b, _c;
    return {
        testCaseId: (_a = o['testCaseId']) !== null && _a !== void 0 ? _a : '',
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
        isValid: (_b = o['isValid']) !== null && _b !== void 0 ? _b : false,
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function testLLMOptionsToJson(m) {
    const o = {};
    if (m.model !== undefined)
        o['model'] = m.model;
    if (m.reasoningEffort !== undefined)
        o['reasoningEffort'] = m.reasoningEffort;
    return o;
}
export function testLLMOptionsFromJson(o) {
    var _a, _b;
    return {
        model: (_a = o['model']) !== null && _a !== void 0 ? _a : '',
        reasoningEffort: (_b = o['reasoningEffort']) !== null && _b !== void 0 ? _b : '',
    };
}
export function expectedToolCallToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.arguments !== undefined)
        o['arguments'] = m.arguments;
    if (m.response !== undefined)
        o['response'] = m.response;
    return o;
}
export function expectedToolCallFromJson(o) {
    var _a, _b, _c;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        arguments: (_b = o['arguments']) !== null && _b !== void 0 ? _b : '',
        response: (_c = o['response']) !== null && _c !== void 0 ? _c : '',
    };
}
export function expectedCitationToJson(m) {
    const o = {};
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.link !== undefined)
        o['link'] = m.link;
    return o;
}
export function expectedCitationFromJson(o) {
    var _a, _b, _c;
    return {
        title: (_a = o['title']) !== null && _a !== void 0 ? _a : '',
        type: (_b = o['type']) !== null && _b !== void 0 ? _b : 'UNSPECIFIED',
        link: (_c = o['link']) !== null && _c !== void 0 ? _c : '',
    };
}
export function testResultToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.chatHistory !== undefined) {
        o['chatHistory'] = m.chatHistory.map(e => chatMessageToJson(e));
    }
    if (m.expected !== undefined)
        o['expected'] = m.expected;
    if (m.evaluation !== undefined)
        o['evaluation'] = m.evaluation;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.score !== undefined)
        o['score'] = m.score;
    if (m.reasoning !== undefined)
        o['reasoning'] = m.reasoning;
    if (m.citations !== undefined) {
        o['citations'] = m.citations.map(e => testResultCitationToJson(e));
    }
    if (m.llmOptions !== undefined)
        o['llmOptions'] = testLLMOptionsToJson(m.llmOptions);
    if (m.latency !== undefined)
        o['latency'] = m.latency;
    if (m.expectedToolCalls !== undefined) {
        o['expectedToolCalls'] = m.expectedToolCalls.map(e => expectedToolCallToJson(e));
    }
    if (m.toolCalls !== undefined) {
        o['toolCalls'] = m.toolCalls.map(e => toolCallToJson(e));
    }
    if (m.chunks !== undefined) {
        o['chunks'] = m.chunks.map(e => testResultChunkToJson(e));
    }
    if (m.agentArchitecture !== undefined)
        o['agentArchitecture'] = m.agentArchitecture;
    if (m.iterationNumber !== undefined)
        o['iterationNumber'] = m.iterationNumber;
    if (m.totalIterations !== undefined)
        o['totalIterations'] = m.totalIterations;
    if (m.testRunId !== undefined)
        o['testRunId'] = m.testRunId;
    if (m.testType !== undefined)
        o['testType'] = m.testType;
    if (m.callRecordId !== undefined)
        o['callRecordId'] = m.callRecordId;
    if (m.recordingUrl !== undefined)
        o['recordingUrl'] = m.recordingUrl;
    if (m.callDuration !== undefined)
        o['callDuration'] = m.callDuration;
    if (m.callerInstructions !== undefined)
        o['callerInstructions'] = m.callerInstructions;
    if (m.expectedCitations !== undefined) {
        o['expectedCitations'] = m.expectedCitations.map(e => expectedCitationToJson(e));
    }
    if (m.voiceConfig !== undefined)
        o['voiceConfig'] = configVoiceConfigToJson(m.voiceConfig);
    if (m.scenario !== undefined)
        o['scenario'] = m.scenario;
    if (m.invocationContext !== undefined)
        o['invocationContext'] = invocationContextToJson(m.invocationContext);
    if (m.sourceConversationId !== undefined)
        o['sourceConversationId'] = m.sourceConversationId;
    if (m.sourceCallRecordId !== undefined)
        o['sourceCallRecordId'] = m.sourceCallRecordId;
    return o;
}
export function testResultFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        chatHistory: ((_c = o['chatHistory']) !== null && _c !== void 0 ? _c : []).map(e => chatMessageFromJson(e)),
        expected: (_d = o['expected']) !== null && _d !== void 0 ? _d : '',
        evaluation: (_e = o['evaluation']) !== null && _e !== void 0 ? _e : '',
        status: (_f = o['status']) !== null && _f !== void 0 ? _f : '',
        score: (_g = o['score']) !== null && _g !== void 0 ? _g : 0,
        reasoning: (_h = o['reasoning']) !== null && _h !== void 0 ? _h : '',
        citations: ((_j = o['citations']) !== null && _j !== void 0 ? _j : []).map(e => testResultCitationFromJson(e)),
        llmOptions: o['llmOptions'] ? testLLMOptionsFromJson(o['llmOptions']) : undefined,
        latency: (_k = o['latency']) !== null && _k !== void 0 ? _k : 0,
        expectedToolCalls: ((_l = o['expectedToolCalls']) !== null && _l !== void 0 ? _l : []).map(e => expectedToolCallFromJson(e)),
        toolCalls: ((_m = o['toolCalls']) !== null && _m !== void 0 ? _m : []).map(e => toolCallFromJson(e)),
        chunks: ((_o = o['chunks']) !== null && _o !== void 0 ? _o : []).map(e => testResultChunkFromJson(e)),
        agentArchitecture: (_p = o['agentArchitecture']) !== null && _p !== void 0 ? _p : 'UNSET',
        iterationNumber: (_q = o['iterationNumber']) !== null && _q !== void 0 ? _q : 0,
        totalIterations: (_r = o['totalIterations']) !== null && _r !== void 0 ? _r : 0,
        testRunId: (_s = o['testRunId']) !== null && _s !== void 0 ? _s : '',
        testType: (_t = o['testType']) !== null && _t !== void 0 ? _t : 'TEST_TYPE_UNSPECIFIED',
        callRecordId: (_u = o['callRecordId']) !== null && _u !== void 0 ? _u : '',
        recordingUrl: (_v = o['recordingUrl']) !== null && _v !== void 0 ? _v : '',
        callDuration: (_w = o['callDuration']) !== null && _w !== void 0 ? _w : 0,
        callerInstructions: (_x = o['callerInstructions']) !== null && _x !== void 0 ? _x : '',
        expectedCitations: ((_y = o['expectedCitations']) !== null && _y !== void 0 ? _y : []).map(e => expectedCitationFromJson(e)),
        voiceConfig: o['voiceConfig'] ? configVoiceConfigFromJson(o['voiceConfig']) : undefined,
        scenario: (_z = o['scenario']) !== null && _z !== void 0 ? _z : '',
        invocationContext: o['invocationContext'] ? invocationContextFromJson(o['invocationContext']) : undefined,
        sourceConversationId: (_0 = o['sourceConversationId']) !== null && _0 !== void 0 ? _0 : '',
        sourceCallRecordId: (_1 = o['sourceCallRecordId']) !== null && _1 !== void 0 ? _1 : '',
    };
}
export function testResultCitationToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.link !== undefined)
        o['link'] = m.link;
    if (m.reason !== undefined)
        o['reason'] = m.reason;
    if (m.fileUrl !== undefined)
        o['fileUrl'] = m.fileUrl;
    if (m.functionArguments !== undefined)
        o['functionArguments'] = m.functionArguments;
    if (m.functionContent !== undefined)
        o['functionContent'] = m.functionContent;
    return o;
}
export function testResultCitationFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : '',
        description: (_b = o['description']) !== null && _b !== void 0 ? _b : '',
        title: (_c = o['title']) !== null && _c !== void 0 ? _c : '',
        link: (_d = o['link']) !== null && _d !== void 0 ? _d : '',
        reason: (_e = o['reason']) !== null && _e !== void 0 ? _e : '',
        fileUrl: (_f = o['fileUrl']) !== null && _f !== void 0 ? _f : '',
        functionArguments: (_g = o['functionArguments']) !== null && _g !== void 0 ? _g : '',
        functionContent: (_h = o['functionContent']) !== null && _h !== void 0 ? _h : '',
    };
}
export function testResultChunkToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.contentType !== undefined)
        o['contentType'] = m.contentType;
    if (m.sequenceNumber !== undefined)
        o['sequenceNumber'] = m.sequenceNumber;
    if (m.timestamp !== undefined)
        o['timestamp'] = m.timestamp.toISOString();
    if (m.isError !== undefined)
        o['isError'] = m.isError;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function testResultChunkFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        contentType: (_b = o['contentType']) !== null && _b !== void 0 ? _b : 'CONTENT_TYPE_UNSPECIFIED',
        sequenceNumber: (_c = o['sequenceNumber']) !== null && _c !== void 0 ? _c : 0,
        timestamp: o['timestamp'] ? new Date(o['timestamp']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        isError: (_d = o['isError']) !== null && _d !== void 0 ? _d : false,
        errorMessage: (_e = o['errorMessage']) !== null && _e !== void 0 ? _e : '',
    };
}
export function testRunToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.testFramework !== undefined)
        o['testFramework'] = m.testFramework;
    if (m.testResults !== undefined) {
        o['testResults'] = m.testResults.map(e => testResultToJson(e));
    }
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.buildUrl !== undefined)
        o['buildUrl'] = m.buildUrl;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.iterations !== undefined)
        o['iterations'] = m.iterations;
    if (m.resultCount !== undefined)
        o['resultCount'] = m.resultCount;
    if (m.successCount !== undefined)
        o['successCount'] = m.successCount;
    if (m.avgLatency !== undefined)
        o['avgLatency'] = m.avgLatency;
    if (m.model !== undefined)
        o['model'] = m.model;
    if (m.reasoningEffort !== undefined)
        o['reasoningEffort'] = m.reasoningEffort;
    if (m.voiceConfig !== undefined)
        o['voiceConfig'] = configVoiceConfigToJson(m.voiceConfig);
    if (m.isSuccessEvaluation !== undefined)
        o['isSuccessEvaluation'] = m.isSuccessEvaluation;
    if (m.sourceConversationId !== undefined)
        o['sourceConversationId'] = m.sourceConversationId;
    if (m.sourceCallRecordId !== undefined)
        o['sourceCallRecordId'] = m.sourceCallRecordId;
    if (m.triggerSource !== undefined)
        o['triggerSource'] = m.triggerSource;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function testRunFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : '',
        testFramework: (_c = o['testFramework']) !== null && _c !== void 0 ? _c : '',
        testResults: ((_d = o['testResults']) !== null && _d !== void 0 ? _d : []).map(e => testResultFromJson(e)),
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        buildUrl: (_e = o['buildUrl']) !== null && _e !== void 0 ? _e : '',
        name: (_f = o['name']) !== null && _f !== void 0 ? _f : '',
        iterations: (_g = o['iterations']) !== null && _g !== void 0 ? _g : 0,
        resultCount: (_h = o['resultCount']) !== null && _h !== void 0 ? _h : 0,
        successCount: (_j = o['successCount']) !== null && _j !== void 0 ? _j : 0,
        avgLatency: (_k = o['avgLatency']) !== null && _k !== void 0 ? _k : 0,
        model: (_l = o['model']) !== null && _l !== void 0 ? _l : '',
        reasoningEffort: (_m = o['reasoningEffort']) !== null && _m !== void 0 ? _m : '',
        voiceConfig: o['voiceConfig'] ? configVoiceConfigFromJson(o['voiceConfig']) : undefined,
        isSuccessEvaluation: (_o = o['isSuccessEvaluation']) !== null && _o !== void 0 ? _o : false,
        sourceConversationId: (_p = o['sourceConversationId']) !== null && _p !== void 0 ? _p : '',
        sourceCallRecordId: (_q = o['sourceCallRecordId']) !== null && _q !== void 0 ? _q : '',
        triggerSource: (_r = o['triggerSource']) !== null && _r !== void 0 ? _r : 'TRIGGER_SOURCE_UNSPECIFIED',
        tags: ((_s = o['tags']) !== null && _s !== void 0 ? _s : []).map(e => keyValuePairFromJson(e)),
    };
}
export function listTestSuitesRequestToJson(m) {
    const o = {};
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    return o;
}
export function listTestSuitesRequestFromJson(o) {
    var _a, _b;
    return {
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        searchTerm: (_a = o['searchTerm']) !== null && _a !== void 0 ? _a : '',
        tags: ((_b = o['tags']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function listTestSuitesResponseToJson(m) {
    const o = {};
    if (m.testSuites !== undefined) {
        o['testSuites'] = m.testSuites.map(e => testSuiteToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listTestSuitesResponseFromJson(o) {
    var _a;
    return {
        testSuites: ((_a = o['testSuites']) !== null && _a !== void 0 ? _a : []).map(e => testSuiteFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function getTestSuiteRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function getTestSuiteRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getTestSuiteResponseToJson(m) {
    const o = {};
    if (m.testSuite !== undefined)
        o['testSuite'] = testSuiteToJson(m.testSuite);
    if (m.testCases !== undefined) {
        o['testCases'] = m.testCases.map(e => testCaseToJson(e));
    }
    return o;
}
export function getTestSuiteResponseFromJson(o) {
    var _a;
    return {
        testSuite: o['testSuite'] ? testSuiteFromJson(o['testSuite']) : undefined,
        testCases: ((_a = o['testCases']) !== null && _a !== void 0 ? _a : []).map(e => testCaseFromJson(e)),
    };
}
export function upsertTestSuiteRequestToJson(m) {
    const o = {};
    if (m.testSuite !== undefined)
        o['testSuite'] = testSuiteToJson(m.testSuite);
    return o;
}
export function upsertTestSuiteRequestFromJson(o) {
    return {
        testSuite: o['testSuite'] ? testSuiteFromJson(o['testSuite']) : undefined,
    };
}
export function upsertTestSuiteResponseToJson(m) {
    const o = {};
    if (m.testSuite !== undefined)
        o['testSuite'] = testSuiteToJson(m.testSuite);
    return o;
}
export function upsertTestSuiteResponseFromJson(o) {
    return {
        testSuite: o['testSuite'] ? testSuiteFromJson(o['testSuite']) : undefined,
    };
}
export function listTestRunsRequestToJson(m) {
    const o = {};
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.onlySuccessEvaluations !== undefined)
        o['onlySuccessEvaluations'] = m.onlySuccessEvaluations;
    if (m.filter !== undefined) {
        if (m.filter.type === 'assistant') {
            o['assistant'] = assistantKeyToJson(m.filter.assistant);
        }
        if (m.filter.type === 'testSuiteId') {
            o['testSuiteId'] = m.filter.testSuiteId;
        }
    }
    else {
        if (m.assistant !== undefined)
            o['assistant'] = assistantKeyToJson(m.assistant);
        if (m.testSuiteId !== undefined)
            o['testSuiteId'] = m.testSuiteId;
    }
    if (m.source !== undefined) {
        if (m.source.type === 'sourceConversationId') {
            o['sourceConversationId'] = m.source.sourceConversationId;
        }
        if (m.source.type === 'sourceCallRecordId') {
            o['sourceCallRecordId'] = m.source.sourceCallRecordId;
        }
    }
    else {
        if (m.sourceConversationId !== undefined)
            o['sourceConversationId'] = m.sourceConversationId;
        if (m.sourceCallRecordId !== undefined)
            o['sourceCallRecordId'] = m.sourceCallRecordId;
    }
    return o;
}
export function listTestRunsRequestFromJson(o) {
    var _a;
    return {
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        onlySuccessEvaluations: (_a = o['onlySuccessEvaluations']) !== null && _a !== void 0 ? _a : false,
        filter: (() => {
            if (o['assistant'] !== undefined)
                return { type: 'assistant', assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined };
            if (o['testSuiteId'] !== undefined)
                return { type: 'testSuiteId', testSuiteId: o['testSuiteId'] };
            return undefined;
        })(),
        assistant: o['assistant'] !== undefined ? o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined : undefined,
        testSuiteId: o['testSuiteId'] !== undefined ? o['testSuiteId'] : undefined,
        source: (() => {
            if (o['sourceConversationId'] !== undefined)
                return { type: 'sourceConversationId', sourceConversationId: o['sourceConversationId'] };
            if (o['sourceCallRecordId'] !== undefined)
                return { type: 'sourceCallRecordId', sourceCallRecordId: o['sourceCallRecordId'] };
            return undefined;
        })(),
        sourceConversationId: o['sourceConversationId'] !== undefined ? o['sourceConversationId'] : undefined,
        sourceCallRecordId: o['sourceCallRecordId'] !== undefined ? o['sourceCallRecordId'] : undefined,
    };
}
export function listTestRunsResponseToJson(m) {
    const o = {};
    if (m.testRuns !== undefined) {
        o['testRuns'] = m.testRuns.map(e => testRunToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listTestRunsResponseFromJson(o) {
    var _a;
    return {
        testRuns: ((_a = o['testRuns']) !== null && _a !== void 0 ? _a : []).map(e => testRunFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function runTestsV2RequestToJson(m) {
    const o = {};
    if (m.testCaseKeys !== undefined) {
        o['testCaseKeys'] = m.testCaseKeys.map(e => testCaseKeyToJson(e));
    }
    if (m.llmOptions !== undefined)
        o['llmOptions'] = testLLMOptionsToJson(m.llmOptions);
    if (m.testRunName !== undefined)
        o['testRunName'] = m.testRunName;
    if (m.iterations !== undefined)
        o['iterations'] = m.iterations;
    if (m.voiceConfig !== undefined)
        o['voiceConfig'] = configVoiceConfigToJson(m.voiceConfig);
    if (m.runType !== undefined) {
        if (m.runType.type === 'assistant') {
            o['assistant'] = assistantKeyToJson(m.runType.assistant);
        }
        if (m.runType.type === 'testSuiteId') {
            o['testSuiteId'] = m.runType.testSuiteId;
        }
    }
    else {
        if (m.assistant !== undefined)
            o['assistant'] = assistantKeyToJson(m.assistant);
        if (m.testSuiteId !== undefined)
            o['testSuiteId'] = m.testSuiteId;
    }
    return o;
}
export function runTestsV2RequestFromJson(o) {
    var _a, _b, _c;
    return {
        testCaseKeys: ((_a = o['testCaseKeys']) !== null && _a !== void 0 ? _a : []).map(e => testCaseKeyFromJson(e)),
        llmOptions: o['llmOptions'] ? testLLMOptionsFromJson(o['llmOptions']) : undefined,
        testRunName: (_b = o['testRunName']) !== null && _b !== void 0 ? _b : '',
        iterations: (_c = o['iterations']) !== null && _c !== void 0 ? _c : 0,
        voiceConfig: o['voiceConfig'] ? configVoiceConfigFromJson(o['voiceConfig']) : undefined,
        runType: (() => {
            if (o['assistant'] !== undefined)
                return { type: 'assistant', assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined };
            if (o['testSuiteId'] !== undefined)
                return { type: 'testSuiteId', testSuiteId: o['testSuiteId'] };
            return undefined;
        })(),
        assistant: o['assistant'] !== undefined ? o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined : undefined,
        testSuiteId: o['testSuiteId'] !== undefined ? o['testSuiteId'] : undefined,
    };
}
export function runTestsV2ResponseToJson(m) {
    const o = {};
    if (m.buildUrl !== undefined)
        o['buildUrl'] = m.buildUrl;
    return o;
}
export function runTestsV2ResponseFromJson(o) {
    var _a;
    return {
        buildUrl: (_a = o['buildUrl']) !== null && _a !== void 0 ? _a : '',
    };
}
export function deleteTestSuiteRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function deleteTestSuiteRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getTestRunV2RequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.runType !== undefined) {
        if (m.runType.type === 'assistant') {
            o['assistant'] = assistantKeyToJson(m.runType.assistant);
        }
        if (m.runType.type === 'testSuiteId') {
            o['testSuiteId'] = m.runType.testSuiteId;
        }
    }
    else {
        if (m.assistant !== undefined)
            o['assistant'] = assistantKeyToJson(m.assistant);
        if (m.testSuiteId !== undefined)
            o['testSuiteId'] = m.testSuiteId;
    }
    return o;
}
export function getTestRunV2RequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        runType: (() => {
            if (o['assistant'] !== undefined)
                return { type: 'assistant', assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined };
            if (o['testSuiteId'] !== undefined)
                return { type: 'testSuiteId', testSuiteId: o['testSuiteId'] };
            return undefined;
        })(),
        assistant: o['assistant'] !== undefined ? o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined : undefined,
        testSuiteId: o['testSuiteId'] !== undefined ? o['testSuiteId'] : undefined,
    };
}
export function getTestRunV2ResponseToJson(m) {
    const o = {};
    if (m.testRun !== undefined)
        o['testRun'] = testRunToJson(m.testRun);
    return o;
}
export function getTestRunV2ResponseFromJson(o) {
    return {
        testRun: o['testRun'] ? testRunFromJson(o['testRun']) : undefined,
    };
}
export function cancelTestRunV2RequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.runType !== undefined) {
        if (m.runType.type === 'assistant') {
            o['assistant'] = assistantKeyToJson(m.runType.assistant);
        }
        if (m.runType.type === 'testSuiteId') {
            o['testSuiteId'] = m.runType.testSuiteId;
        }
    }
    else {
        if (m.assistant !== undefined)
            o['assistant'] = assistantKeyToJson(m.assistant);
        if (m.testSuiteId !== undefined)
            o['testSuiteId'] = m.testSuiteId;
    }
    return o;
}
export function cancelTestRunV2RequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        runType: (() => {
            if (o['assistant'] !== undefined)
                return { type: 'assistant', assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined };
            if (o['testSuiteId'] !== undefined)
                return { type: 'testSuiteId', testSuiteId: o['testSuiteId'] };
            return undefined;
        })(),
        assistant: o['assistant'] !== undefined ? o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined : undefined,
        testSuiteId: o['testSuiteId'] !== undefined ? o['testSuiteId'] : undefined,
    };
}
export function listTestResultsRequestToJson(m) {
    const o = {};
    if (m.testRunId !== undefined)
        o['testRunId'] = m.testRunId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.runType !== undefined) {
        if (m.runType.type === 'assistant') {
            o['assistant'] = assistantKeyToJson(m.runType.assistant);
        }
        if (m.runType.type === 'testSuiteId') {
            o['testSuiteId'] = m.runType.testSuiteId;
        }
    }
    else {
        if (m.assistant !== undefined)
            o['assistant'] = assistantKeyToJson(m.assistant);
        if (m.testSuiteId !== undefined)
            o['testSuiteId'] = m.testSuiteId;
    }
    return o;
}
export function listTestResultsRequestFromJson(o) {
    var _a;
    return {
        testRunId: (_a = o['testRunId']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        runType: (() => {
            if (o['assistant'] !== undefined)
                return { type: 'assistant', assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined };
            if (o['testSuiteId'] !== undefined)
                return { type: 'testSuiteId', testSuiteId: o['testSuiteId'] };
            return undefined;
        })(),
        assistant: o['assistant'] !== undefined ? o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined : undefined,
        testSuiteId: o['testSuiteId'] !== undefined ? o['testSuiteId'] : undefined,
    };
}
export function listTestResultsResponseToJson(m) {
    const o = {};
    if (m.testResults !== undefined) {
        o['testResults'] = m.testResults.map(e => testResultToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listTestResultsResponseFromJson(o) {
    var _a;
    return {
        testResults: ((_a = o['testResults']) !== null && _a !== void 0 ? _a : []).map(e => testResultFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function retryStuckTestResultsRequestToJson(m) {
    const o = {};
    if (m.testRunId !== undefined)
        o['testRunId'] = m.testRunId;
    if (m.runType !== undefined) {
        if (m.runType.type === 'assistant') {
            o['assistant'] = assistantKeyToJson(m.runType.assistant);
        }
        if (m.runType.type === 'testSuiteId') {
            o['testSuiteId'] = m.runType.testSuiteId;
        }
    }
    else {
        if (m.assistant !== undefined)
            o['assistant'] = assistantKeyToJson(m.assistant);
        if (m.testSuiteId !== undefined)
            o['testSuiteId'] = m.testSuiteId;
    }
    return o;
}
export function retryStuckTestResultsRequestFromJson(o) {
    var _a;
    return {
        testRunId: (_a = o['testRunId']) !== null && _a !== void 0 ? _a : '',
        runType: (() => {
            if (o['assistant'] !== undefined)
                return { type: 'assistant', assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined };
            if (o['testSuiteId'] !== undefined)
                return { type: 'testSuiteId', testSuiteId: o['testSuiteId'] };
            return undefined;
        })(),
        assistant: o['assistant'] !== undefined ? o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined : undefined,
        testSuiteId: o['testSuiteId'] !== undefined ? o['testSuiteId'] : undefined,
    };
}
export function retryStuckTestResultsResponseToJson(m) {
    const o = {};
    if (m.buildUrl !== undefined)
        o['buildUrl'] = m.buildUrl;
    return o;
}
export function retryStuckTestResultsResponseFromJson(o) {
    var _a;
    return {
        buildUrl: (_a = o['buildUrl']) !== null && _a !== void 0 ? _a : '',
    };
}
export function generateTestCasesRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    if (m.instructions !== undefined)
        o['instructions'] = m.instructions;
    if (m.testType !== undefined)
        o['testType'] = m.testType;
    return o;
}
export function generateTestCasesRequestFromJson(o) {
    var _a, _b;
    return {
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
        instructions: (_a = o['instructions']) !== null && _a !== void 0 ? _a : '',
        testType: (_b = o['testType']) !== null && _b !== void 0 ? _b : 'TEST_TYPE_UNSPECIFIED',
    };
}
export function generateTestCasesResponseToJson(m) {
    const o = {};
    if (m.testCases !== undefined) {
        o['testCases'] = m.testCases.map(e => testCaseToJson(e));
    }
    return o;
}
export function generateTestCasesResponseFromJson(o) {
    var _a;
    return {
        testCases: ((_a = o['testCases']) !== null && _a !== void 0 ? _a : []).map(e => testCaseFromJson(e)),
    };
}
export function runSuccessEvaluationRequestToJson(m) {
    const o = {};
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    if (m.source !== undefined) {
        if (m.source.type === 'conversationId') {
            o['conversationId'] = m.source.conversationId;
        }
        if (m.source.type === 'callRecordId') {
            o['callRecordId'] = m.source.callRecordId;
        }
    }
    else {
        if (m.conversationId !== undefined)
            o['conversationId'] = m.conversationId;
        if (m.callRecordId !== undefined)
            o['callRecordId'] = m.callRecordId;
    }
    return o;
}
export function runSuccessEvaluationRequestFromJson(o) {
    return {
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
        source: (() => {
            if (o['conversationId'] !== undefined)
                return { type: 'conversationId', conversationId: o['conversationId'] };
            if (o['callRecordId'] !== undefined)
                return { type: 'callRecordId', callRecordId: o['callRecordId'] };
            return undefined;
        })(),
        conversationId: o['conversationId'] !== undefined ? o['conversationId'] : undefined,
        callRecordId: o['callRecordId'] !== undefined ? o['callRecordId'] : undefined,
    };
}
export function runSuccessEvaluationResponseToJson(m) {
    const o = {};
    if (m.testRunId !== undefined)
        o['testRunId'] = m.testRunId;
    return o;
}
export function runSuccessEvaluationResponseFromJson(o) {
    var _a;
    return {
        testRunId: (_a = o['testRunId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function cancelSuccessEvaluationRequestToJson(m) {
    const o = {};
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    if (m.testRunId !== undefined)
        o['testRunId'] = m.testRunId;
    return o;
}
export function cancelSuccessEvaluationRequestFromJson(o) {
    var _a;
    return {
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
        testRunId: (_a = o['testRunId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function bulkSamplingTierToJson(m) {
    const o = {};
    if (m.rate !== undefined)
        o['rate'] = m.rate;
    if (m.floorMin !== undefined)
        o['floorMin'] = m.floorMin;
    if (m.floorPct !== undefined)
        o['floorPct'] = m.floorPct;
    return o;
}
export function bulkSamplingTierFromJson(o) {
    var _a, _b, _c;
    return {
        rate: (_a = o['rate']) !== null && _a !== void 0 ? _a : 0,
        floorMin: (_b = o['floorMin']) !== null && _b !== void 0 ? _b : 0,
        floorPct: (_c = o['floorPct']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function bulkSamplingPolicyToJson(m) {
    const o = {};
    if (m.automation !== undefined)
        o['automation'] = bulkSamplingTierToJson(m.automation);
    if (m.chat !== undefined)
        o['chat'] = bulkSamplingTierToJson(m.chat);
    if (m.voice !== undefined)
        o['voice'] = bulkSamplingTierToJson(m.voice);
    return o;
}
export function bulkSamplingPolicyFromJson(o) {
    return {
        automation: o['automation'] ? bulkSamplingTierFromJson(o['automation']) : undefined,
        chat: o['chat'] ? bulkSamplingTierFromJson(o['chat']) : undefined,
        voice: o['voice'] ? bulkSamplingTierFromJson(o['voice']) : undefined,
    };
}
export function startBulkSuccessEvaluationRequestToJson(m) {
    const o = {};
    if (m.endTime !== undefined)
        o['endTime'] = m.endTime.toISOString();
    if (m.lookbackHours !== undefined)
        o['lookbackHours'] = m.lookbackHours;
    if (m.automations !== undefined)
        o['automations'] = m.automations;
    if (m.partnerIds !== undefined) {
        o['partnerIds'] = m.partnerIds.map(e => e);
    }
    if (m.sampling !== undefined)
        o['sampling'] = bulkSamplingPolicyToJson(m.sampling);
    return o;
}
export function startBulkSuccessEvaluationRequestFromJson(o) {
    var _a, _b, _c;
    return {
        endTime: o['endTime'] ? new Date(o['endTime']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        lookbackHours: (_a = o['lookbackHours']) !== null && _a !== void 0 ? _a : 0,
        automations: (_b = o['automations']) !== null && _b !== void 0 ? _b : 'BULK_AUTOMATION_FILTER_ALL',
        partnerIds: ((_c = o['partnerIds']) !== null && _c !== void 0 ? _c : []).map(e => e),
        sampling: o['sampling'] ? bulkSamplingPolicyFromJson(o['sampling']) : undefined,
    };
}
export function startBulkSuccessEvaluationResponseToJson(m) {
    const o = {};
    if (m.workflowId !== undefined)
        o['workflowId'] = m.workflowId;
    if (m.runId !== undefined)
        o['runId'] = m.runId;
    return o;
}
export function startBulkSuccessEvaluationResponseFromJson(o) {
    var _a, _b;
    return {
        workflowId: (_a = o['workflowId']) !== null && _a !== void 0 ? _a : '',
        runId: (_b = o['runId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listSuccessEvaluatorStatsForAssistantRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    return o;
}
export function listSuccessEvaluatorStatsForAssistantRequestFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
    };
}
export function successEvaluatorStatToJson(m) {
    const o = {};
    if (m.testCase !== undefined)
        o['testCase'] = testCaseToJson(m.testCase);
    if (m.successRate !== undefined)
        o['successRate'] = m.successRate;
    if (m.evaluatedCount !== undefined)
        o['evaluatedCount'] = m.evaluatedCount;
    return o;
}
export function successEvaluatorStatFromJson(o) {
    var _a, _b;
    return {
        testCase: o['testCase'] ? testCaseFromJson(o['testCase']) : undefined,
        successRate: (_a = o['successRate']) !== null && _a !== void 0 ? _a : 0,
        evaluatedCount: (_b = o['evaluatedCount']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function listSuccessEvaluatorStatsForAssistantResponseToJson(m) {
    const o = {};
    if (m.evaluators !== undefined) {
        o['evaluators'] = m.evaluators.map(e => successEvaluatorStatToJson(e));
    }
    return o;
}
export function listSuccessEvaluatorStatsForAssistantResponseFromJson(o) {
    var _a;
    return {
        evaluators: ((_a = o['evaluators']) !== null && _a !== void 0 ? _a : []).map(e => successEvaluatorStatFromJson(e)),
    };
}
export function listSuccessEvaluatorResultsRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantKeyToJson(m.assistant);
    if (m.testCaseId !== undefined)
        o['testCaseId'] = m.testCaseId;
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listSuccessEvaluatorResultsRequestFromJson(o) {
    var _a;
    return {
        assistant: o['assistant'] ? assistantKeyFromJson(o['assistant']) : undefined,
        testCaseId: (_a = o['testCaseId']) !== null && _a !== void 0 ? _a : '',
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listSuccessEvaluatorResultsResponseToJson(m) {
    const o = {};
    if (m.testResults !== undefined) {
        o['testResults'] = m.testResults.map(e => testResultToJson(e));
    }
    if (m.pagingMetadata !== undefined)
        o['pagingMetadata'] = pagedResponseMetadataToJson(m.pagingMetadata);
    return o;
}
export function listSuccessEvaluatorResultsResponseFromJson(o) {
    var _a;
    return {
        testResults: ((_a = o['testResults']) !== null && _a !== void 0 ? _a : []).map(e => testResultFromJson(e)),
        pagingMetadata: o['pagingMetadata'] ? pagedResponseMetadataFromJson(o['pagingMetadata']) : undefined,
    };
}
export function sessionEventToJson(m) {
    const o = {};
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.eventType !== undefined)
        o['eventType'] = m.eventType;
    if (m.runId !== undefined)
        o['runId'] = m.runId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.externalId !== undefined)
        o['externalId'] = m.externalId;
    if (m.assistantId !== undefined)
        o['assistantId'] = m.assistantId;
    if (m.payload !== undefined) {
        if (m.payload.type === 'message') {
            o['message'] = sessionMessageDataToJson(m.payload.message);
        }
        if (m.payload.type === 'thought') {
            o['thought'] = sessionThoughtDataToJson(m.payload.thought);
        }
        if (m.payload.type === 'toolCall') {
            o['toolCall'] = sessionToolCallDataToJson(m.payload.toolCall);
        }
        if (m.payload.type === 'proposedAction') {
            o['proposedAction'] = sessionProposedActionDataToJson(m.payload.proposedAction);
        }
    }
    else {
        if (m.message !== undefined)
            o['message'] = sessionMessageDataToJson(m.message);
        if (m.thought !== undefined)
            o['thought'] = sessionThoughtDataToJson(m.thought);
        if (m.toolCall !== undefined)
            o['toolCall'] = sessionToolCallDataToJson(m.toolCall);
        if (m.proposedAction !== undefined)
            o['proposedAction'] = sessionProposedActionDataToJson(m.proposedAction);
    }
    return o;
}
export function sessionEventFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        eventId: (_a = o['eventId']) !== null && _a !== void 0 ? _a : '',
        sessionId: (_b = o['sessionId']) !== null && _b !== void 0 ? _b : '',
        eventType: (_c = o['eventType']) !== null && _c !== void 0 ? _c : 'SESSION_EVENT_TYPE_INVALID',
        runId: (_d = o['runId']) !== null && _d !== void 0 ? _d : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        externalId: (_e = o['externalId']) !== null && _e !== void 0 ? _e : '',
        assistantId: (_f = o['assistantId']) !== null && _f !== void 0 ? _f : '',
        payload: (() => {
            if (o['message'] !== undefined)
                return { type: 'message', message: o['message'] ? sessionMessageDataFromJson(o['message']) : undefined };
            if (o['thought'] !== undefined)
                return { type: 'thought', thought: o['thought'] ? sessionThoughtDataFromJson(o['thought']) : undefined };
            if (o['toolCall'] !== undefined)
                return { type: 'toolCall', toolCall: o['toolCall'] ? sessionToolCallDataFromJson(o['toolCall']) : undefined };
            if (o['proposedAction'] !== undefined)
                return { type: 'proposedAction', proposedAction: o['proposedAction'] ? sessionProposedActionDataFromJson(o['proposedAction']) : undefined };
            return undefined;
        })(),
        message: o['message'] !== undefined ? o['message'] ? sessionMessageDataFromJson(o['message']) : undefined : undefined,
        thought: o['thought'] !== undefined ? o['thought'] ? sessionThoughtDataFromJson(o['thought']) : undefined : undefined,
        toolCall: o['toolCall'] !== undefined ? o['toolCall'] ? sessionToolCallDataFromJson(o['toolCall']) : undefined : undefined,
        proposedAction: o['proposedAction'] !== undefined ? o['proposedAction'] ? sessionProposedActionDataFromJson(o['proposedAction']) : undefined : undefined,
    };
}
export function sessionMessageDataToJson(m) {
    const o = {};
    if (m.role !== undefined)
        o['role'] = m.role;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.contentParts !== undefined) {
        o['contentParts'] = m.contentParts.map(e => chatContentToJson(e));
    }
    if (m.toolCallIds !== undefined) {
        o['toolCallIds'] = m.toolCallIds.map(e => e);
    }
    return o;
}
export function sessionMessageDataFromJson(o) {
    var _a, _b, _c, _d;
    return {
        role: (_a = o['role']) !== null && _a !== void 0 ? _a : 'CHAT_MESSAGE_ROLE_INVALID',
        content: (_b = o['content']) !== null && _b !== void 0 ? _b : '',
        contentParts: ((_c = o['contentParts']) !== null && _c !== void 0 ? _c : []).map(e => chatContentFromJson(e)),
        toolCallIds: ((_d = o['toolCallIds']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function sessionThoughtDataToJson(m) {
    const o = {};
    if (m.contentType !== undefined)
        o['contentType'] = m.contentType;
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function sessionThoughtDataFromJson(o) {
    var _a, _b;
    return {
        contentType: (_a = o['contentType']) !== null && _a !== void 0 ? _a : 'CONTENT_TYPE_UNSPECIFIED',
        content: (_b = o['content']) !== null && _b !== void 0 ? _b : '',
    };
}
export function sessionToolCallDataToJson(m) {
    const o = {};
    if (m.functionCallId !== undefined)
        o['functionCallId'] = m.functionCallId;
    if (m.functionName !== undefined)
        o['functionName'] = m.functionName;
    if (m.arguments !== undefined)
        o['arguments'] = m.arguments;
    if (m.response !== undefined)
        o['response'] = m.response;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    if (m.latencyMs !== undefined)
        o['latencyMs'] = m.latencyMs;
    if (m.truncated !== undefined)
        o['truncated'] = m.truncated;
    if (m.originalSize !== undefined)
        o['originalSize'] = m.originalSize;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.headers !== undefined) {
        o['headers'] = m.headers.map(e => keyValuePairToJson(e));
    }
    if (m.methodType !== undefined)
        o['methodType'] = m.methodType;
    return o;
}
export function sessionToolCallDataFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        functionCallId: (_a = o['functionCallId']) !== null && _a !== void 0 ? _a : '',
        functionName: (_b = o['functionName']) !== null && _b !== void 0 ? _b : '',
        arguments: (_c = o['arguments']) !== null && _c !== void 0 ? _c : '',
        response: (_d = o['response']) !== null && _d !== void 0 ? _d : '',
        status: (_e = o['status']) !== null && _e !== void 0 ? _e : '',
        errorMessage: (_f = o['errorMessage']) !== null && _f !== void 0 ? _f : '',
        latencyMs: (_g = o['latencyMs']) !== null && _g !== void 0 ? _g : 0,
        truncated: (_h = o['truncated']) !== null && _h !== void 0 ? _h : false,
        originalSize: (_j = o['originalSize']) !== null && _j !== void 0 ? _j : 0,
        url: (_k = o['url']) !== null && _k !== void 0 ? _k : '',
        headers: ((_l = o['headers']) !== null && _l !== void 0 ? _l : []).map(e => keyValuePairFromJson(e)),
        methodType: (_m = o['methodType']) !== null && _m !== void 0 ? _m : '',
    };
}
export function sessionProposedActionDataToJson(m) {
    const o = {};
    if (m.functionId !== undefined)
        o['functionId'] = m.functionId;
    if (m.arguments !== undefined)
        o['arguments'] = m.arguments;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.reasoningSummary !== undefined)
        o['reasoningSummary'] = m.reasoningSummary;
    if (m.feedback !== undefined)
        o['feedback'] = m.feedback;
    if (m.reviewedBy !== undefined)
        o['reviewedBy'] = m.reviewedBy;
    if (m.statusChangedAt !== undefined)
        o['statusChangedAt'] = m.statusChangedAt.toISOString();
    if (m.executionEventId !== undefined)
        o['executionEventId'] = m.executionEventId;
    if (m.approveText !== undefined)
        o['approveText'] = m.approveText;
    if (m.title !== undefined)
        o['title'] = m.title;
    if (m.description !== undefined)
        o['description'] = m.description;
    return o;
}
export function sessionProposedActionDataFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        functionId: (_a = o['functionId']) !== null && _a !== void 0 ? _a : '',
        arguments: (_b = o['arguments']) !== null && _b !== void 0 ? _b : '',
        status: (_c = o['status']) !== null && _c !== void 0 ? _c : 'INVALID',
        reasoningSummary: (_d = o['reasoningSummary']) !== null && _d !== void 0 ? _d : '',
        feedback: (_e = o['feedback']) !== null && _e !== void 0 ? _e : '',
        reviewedBy: (_f = o['reviewedBy']) !== null && _f !== void 0 ? _f : '',
        statusChangedAt: o['statusChangedAt'] ? new Date(o['statusChangedAt']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        executionEventId: (_g = o['executionEventId']) !== null && _g !== void 0 ? _g : '',
        approveText: (_h = o['approveText']) !== null && _h !== void 0 ? _h : '',
        title: (_j = o['title']) !== null && _j !== void 0 ? _j : '',
        description: (_k = o['description']) !== null && _k !== void 0 ? _k : '',
    };
}
export function sessionToJson(m) {
    const o = {};
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.updated !== undefined)
        o['updated'] = m.updated.toISOString();
    if (m.activeRunId !== undefined)
        o['activeRunId'] = m.activeRunId;
    if (m.runStarted !== undefined)
        o['runStarted'] = m.runStarted.toISOString();
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    return o;
}
export function sessionFromJson(o) {
    var _a, _b, _c;
    return {
        sessionId: (_a = o['sessionId']) !== null && _a !== void 0 ? _a : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        updated: o['updated'] ? new Date(o['updated']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        activeRunId: (_b = o['activeRunId']) !== null && _b !== void 0 ? _b : '',
        runStarted: o['runStarted'] ? new Date(o['runStarted']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        tags: ((_c = o['tags']) !== null && _c !== void 0 ? _c : []).map(e => e),
    };
}
export function approveProposedActionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    return o;
}
export function approveProposedActionRequestFromJson(o) {
    var _a, _b;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        sessionId: (_a = o['sessionId']) !== null && _a !== void 0 ? _a : '',
        eventId: (_b = o['eventId']) !== null && _b !== void 0 ? _b : '',
    };
}
export function approveProposedActionResponseToJson(m) {
    const o = {};
    return o;
}
export function approveProposedActionResponseFromJson(o) {
    return {};
}
export function rejectProposedActionRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    if (m.feedback !== undefined)
        o['feedback'] = m.feedback;
    return o;
}
export function rejectProposedActionRequestFromJson(o) {
    var _a, _b, _c;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        sessionId: (_a = o['sessionId']) !== null && _a !== void 0 ? _a : '',
        eventId: (_b = o['eventId']) !== null && _b !== void 0 ? _b : '',
        feedback: (_c = o['feedback']) !== null && _c !== void 0 ? _c : '',
    };
}
export function rejectProposedActionResponseToJson(m) {
    const o = {};
    return o;
}
export function rejectProposedActionResponseFromJson(o) {
    return {};
}
export function listProposedActionsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.statusFilter !== undefined)
        o['statusFilter'] = m.statusFilter;
    return o;
}
export function listProposedActionsRequestFromJson(o) {
    var _a;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        statusFilter: (_a = o['statusFilter']) !== null && _a !== void 0 ? _a : 'INVALID',
    };
}
export function proposedActionItemToJson(m) {
    const o = {};
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    if (m.data !== undefined)
        o['data'] = sessionProposedActionDataToJson(m.data);
    if (m.assistantId !== undefined)
        o['assistantId'] = m.assistantId;
    if (m.created !== undefined)
        o['created'] = m.created.toISOString();
    if (m.functionName !== undefined)
        o['functionName'] = m.functionName;
    return o;
}
export function proposedActionItemFromJson(o) {
    var _a, _b, _c, _d;
    return {
        sessionId: (_a = o['sessionId']) !== null && _a !== void 0 ? _a : '',
        eventId: (_b = o['eventId']) !== null && _b !== void 0 ? _b : '',
        data: o['data'] ? sessionProposedActionDataFromJson(o['data']) : undefined,
        assistantId: (_c = o['assistantId']) !== null && _c !== void 0 ? _c : '',
        created: o['created'] ? new Date(o['created']) : undefined !== null && undefined !== void 0 ? undefined : undefined,
        functionName: (_d = o['functionName']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listProposedActionsResponseToJson(m) {
    const o = {};
    if (m.proposedActions !== undefined) {
        o['proposedActions'] = m.proposedActions.map(e => proposedActionItemToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listProposedActionsResponseFromJson(o) {
    var _a;
    return {
        proposedActions: ((_a = o['proposedActions']) !== null && _a !== void 0 ? _a : []).map(e => proposedActionItemFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function upsertAssistantRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    if (m.options !== undefined)
        o['options'] = upsertAssistantRequestOptionsToJson(m.options);
    if (m.currentVersion !== undefined)
        o['currentVersion'] = m.currentVersion;
    if (m.versionType !== undefined)
        o['versionType'] = m.versionType;
    if (m.versionMessage !== undefined)
        o['versionMessage'] = m.versionMessage;
    return o;
}
export function upsertAssistantRequestFromJson(o) {
    var _a, _b, _c;
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
        options: o['options'] ? upsertAssistantRequestOptionsFromJson(o['options']) : undefined,
        currentVersion: (_a = o['currentVersion']) !== null && _a !== void 0 ? _a : '',
        versionType: (_b = o['versionType']) !== null && _b !== void 0 ? _b : 'VERSION_TYPE_INVALID',
        versionMessage: (_c = o['versionMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function upsertAssistantRequestOptionsToJson(m) {
    const o = {};
    if (m.applyDefaults !== undefined)
        o['applyDefaults'] = m.applyDefaults;
    return o;
}
export function upsertAssistantRequestOptionsFromJson(o) {
    var _a;
    return {
        applyDefaults: (_a = o['applyDefaults']) !== null && _a !== void 0 ? _a : false,
    };
}
export function upsertAssistantResponseToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    if (m.versionKey !== undefined)
        o['versionKey'] = assistantVersionKeyToJson(m.versionKey);
    return o;
}
export function upsertAssistantResponseFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
        versionKey: o['versionKey'] ? assistantVersionKeyFromJson(o['versionKey']) : undefined,
    };
}
export function createAssistantRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    if (m.options !== undefined)
        o['options'] = createAssistantRequestOptionsToJson(m.options);
    return o;
}
export function createAssistantRequestFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
        options: o['options'] ? createAssistantRequestOptionsFromJson(o['options']) : undefined,
    };
}
export function createAssistantRequestOptionsToJson(m) {
    const o = {};
    if (m.applyDefaults !== undefined)
        o['applyDefaults'] = m.applyDefaults;
    return o;
}
export function createAssistantRequestOptionsFromJson(o) {
    var _a;
    return {
        applyDefaults: (_a = o['applyDefaults']) !== null && _a !== void 0 ? _a : false,
    };
}
export function createAssistantResponseToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    return o;
}
export function createAssistantResponseFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
    };
}
export function updateAssistantRequestToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateAssistantRequestFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function promptModuleUpdateToJson(m) {
    const o = {};
    if (m.promptModule !== undefined)
        o['promptModule'] = promptModuleToJson(m.promptModule);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function promptModuleUpdateFromJson(o) {
    var _a;
    return {
        promptModule: o['promptModule'] ? promptModuleFromJson(o['promptModule']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
    };
}
export function functionUpdateToJson(m) {
    const o = {};
    if (m.function !== undefined)
        o['function'] = functionToJson(m.function);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function functionUpdateFromJson(o) {
    return {
        function: o['function'] ? functionFromJson(o['function']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function goalUpdateToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.currentVersion !== undefined)
        o['currentVersion'] = m.currentVersion;
    return o;
}
export function goalUpdateFromJson(o) {
    var _a;
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        currentVersion: (_a = o['currentVersion']) !== null && _a !== void 0 ? _a : '',
    };
}
export function assistantUpdateToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    if (m.currentVersion !== undefined)
        o['currentVersion'] = m.currentVersion;
    return o;
}
export function assistantUpdateFromJson(o) {
    var _a;
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
        currentVersion: (_a = o['currentVersion']) !== null && _a !== void 0 ? _a : '',
    };
}
export function promptModuleCreateToJson(m) {
    const o = {};
    if (m.promptModule !== undefined)
        o['promptModule'] = promptModuleToJson(m.promptModule);
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.ref !== undefined)
        o['ref'] = m.ref;
    return o;
}
export function promptModuleCreateFromJson(o) {
    var _a, _b;
    return {
        promptModule: o['promptModule'] ? promptModuleFromJson(o['promptModule']) : undefined,
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        ref: (_b = o['ref']) !== null && _b !== void 0 ? _b : '',
    };
}
export function functionCreateToJson(m) {
    const o = {};
    if (m.function !== undefined)
        o['function'] = functionToJson(m.function);
    return o;
}
export function functionCreateFromJson(o) {
    return {
        function: o['function'] ? functionFromJson(o['function']) : undefined,
    };
}
export function goalCreateToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    if (m.ref !== undefined)
        o['ref'] = m.ref;
    return o;
}
export function goalCreateFromJson(o) {
    var _a;
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
        ref: (_a = o['ref']) !== null && _a !== void 0 ? _a : '',
    };
}
export function assistantCreateToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    if (m.ref !== undefined)
        o['ref'] = m.ref;
    return o;
}
export function assistantCreateFromJson(o) {
    var _a;
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
        ref: (_a = o['ref']) !== null && _a !== void 0 ? _a : '',
    };
}
export function applyAssistantUpdatesRequestToJson(m) {
    const o = {};
    if (m.promptModuleUpdates !== undefined) {
        o['promptModuleUpdates'] = m.promptModuleUpdates.map(e => promptModuleUpdateToJson(e));
    }
    if (m.functionUpdates !== undefined) {
        o['functionUpdates'] = m.functionUpdates.map(e => functionUpdateToJson(e));
    }
    if (m.goalUpdates !== undefined) {
        o['goalUpdates'] = m.goalUpdates.map(e => goalUpdateToJson(e));
    }
    if (m.assistantUpdates !== undefined) {
        o['assistantUpdates'] = m.assistantUpdates.map(e => assistantUpdateToJson(e));
    }
    if (m.versionMessage !== undefined)
        o['versionMessage'] = m.versionMessage;
    if (m.versionType !== undefined)
        o['versionType'] = m.versionType;
    if (m.promptModuleCreates !== undefined) {
        o['promptModuleCreates'] = m.promptModuleCreates.map(e => promptModuleCreateToJson(e));
    }
    if (m.functionCreates !== undefined) {
        o['functionCreates'] = m.functionCreates.map(e => functionCreateToJson(e));
    }
    if (m.goalCreates !== undefined) {
        o['goalCreates'] = m.goalCreates.map(e => goalCreateToJson(e));
    }
    if (m.assistantCreates !== undefined) {
        o['assistantCreates'] = m.assistantCreates.map(e => assistantCreateToJson(e));
    }
    return o;
}
export function applyAssistantUpdatesRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        promptModuleUpdates: ((_a = o['promptModuleUpdates']) !== null && _a !== void 0 ? _a : []).map(e => promptModuleUpdateFromJson(e)),
        functionUpdates: ((_b = o['functionUpdates']) !== null && _b !== void 0 ? _b : []).map(e => functionUpdateFromJson(e)),
        goalUpdates: ((_c = o['goalUpdates']) !== null && _c !== void 0 ? _c : []).map(e => goalUpdateFromJson(e)),
        assistantUpdates: ((_d = o['assistantUpdates']) !== null && _d !== void 0 ? _d : []).map(e => assistantUpdateFromJson(e)),
        versionMessage: (_e = o['versionMessage']) !== null && _e !== void 0 ? _e : '',
        versionType: (_f = o['versionType']) !== null && _f !== void 0 ? _f : 'VERSION_TYPE_INVALID',
        promptModuleCreates: ((_g = o['promptModuleCreates']) !== null && _g !== void 0 ? _g : []).map(e => promptModuleCreateFromJson(e)),
        functionCreates: ((_h = o['functionCreates']) !== null && _h !== void 0 ? _h : []).map(e => functionCreateFromJson(e)),
        goalCreates: ((_j = o['goalCreates']) !== null && _j !== void 0 ? _j : []).map(e => goalCreateFromJson(e)),
        assistantCreates: ((_k = o['assistantCreates']) !== null && _k !== void 0 ? _k : []).map(e => assistantCreateFromJson(e)),
    };
}
export function resolvedRefToJson(m) {
    const o = {};
    if (m.ref !== undefined)
        o['ref'] = m.ref;
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function resolvedRefFromJson(o) {
    var _a, _b;
    return {
        ref: (_a = o['ref']) !== null && _a !== void 0 ? _a : '',
        id: (_b = o['id']) !== null && _b !== void 0 ? _b : '',
    };
}
export function applyAssistantUpdatesResponseToJson(m) {
    const o = {};
    if (m.promptModuleVersions !== undefined) {
        o['promptModuleVersions'] = m.promptModuleVersions.map(e => promptModuleVersionKeyToJson(e));
    }
    if (m.functionVersions !== undefined) {
        o['functionVersions'] = m.functionVersions.map(e => functionVersionKeyToJson(e));
    }
    if (m.goalVersions !== undefined) {
        o['goalVersions'] = m.goalVersions.map(e => goalVersionKeyToJson(e));
    }
    if (m.assistantVersions !== undefined) {
        o['assistantVersions'] = m.assistantVersions.map(e => assistantVersionKeyToJson(e));
    }
    if (m.resolvedRefs !== undefined) {
        o['resolvedRefs'] = m.resolvedRefs.map(e => resolvedRefToJson(e));
    }
    return o;
}
export function applyAssistantUpdatesResponseFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        promptModuleVersions: ((_a = o['promptModuleVersions']) !== null && _a !== void 0 ? _a : []).map(e => promptModuleVersionKeyFromJson(e)),
        functionVersions: ((_b = o['functionVersions']) !== null && _b !== void 0 ? _b : []).map(e => functionVersionKeyFromJson(e)),
        goalVersions: ((_c = o['goalVersions']) !== null && _c !== void 0 ? _c : []).map(e => goalVersionKeyFromJson(e)),
        assistantVersions: ((_d = o['assistantVersions']) !== null && _d !== void 0 ? _d : []).map(e => assistantVersionKeyFromJson(e)),
        resolvedRefs: ((_e = o['resolvedRefs']) !== null && _e !== void 0 ? _e : []).map(e => resolvedRefFromJson(e)),
    };
}
export function getAssistantRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.options !== undefined)
        o['options'] = getAssistantRequestOptionsToJson(m.options);
    return o;
}
export function getAssistantRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        options: o['options'] ? getAssistantRequestOptionsFromJson(o['options']) : undefined,
    };
}
export function getAssistantRequestOptionsToJson(m) {
    const o = {};
    if (m.skipGoalsHydration !== undefined)
        o['skipGoalsHydration'] = m.skipGoalsHydration;
    if (m.invocationContext !== undefined)
        o['invocationContext'] = invocationContextToJson(m.invocationContext);
    return o;
}
export function getAssistantRequestOptionsFromJson(o) {
    var _a;
    return {
        skipGoalsHydration: (_a = o['skipGoalsHydration']) !== null && _a !== void 0 ? _a : false,
        invocationContext: o['invocationContext'] ? invocationContextFromJson(o['invocationContext']) : undefined,
    };
}
export function getAssistantResponseToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    return o;
}
export function getAssistantResponseFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
    };
}
export function getMultiAssistantByUserIDRequestToJson(m) {
    const o = {};
    if (m.userIds !== undefined) {
        o['userIds'] = m.userIds.map(e => e);
    }
    return o;
}
export function getMultiAssistantByUserIDRequestFromJson(o) {
    var _a;
    return {
        userIds: ((_a = o['userIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getMultiAssistantByUserIDResponseToJson(m) {
    const o = {};
    if (m.assistants !== undefined) {
        o['assistants'] = m.assistants.map(e => assistantToJson(e));
    }
    return o;
}
export function getMultiAssistantByUserIDResponseFromJson(o) {
    var _a;
    return {
        assistants: ((_a = o['assistants']) !== null && _a !== void 0 ? _a : []).map(e => assistantFromJson(e)),
    };
}
export function getMultiAssistantRequestToJson(m) {
    const o = {};
    if (m.assistantKeys !== undefined) {
        o['assistantKeys'] = m.assistantKeys.map(e => assistantKeyToJson(e));
    }
    if (m.options !== undefined)
        o['options'] = getMultiAssistantRequestOptionsToJson(m.options);
    return o;
}
export function getMultiAssistantRequestFromJson(o) {
    var _a;
    return {
        assistantKeys: ((_a = o['assistantKeys']) !== null && _a !== void 0 ? _a : []).map(e => assistantKeyFromJson(e)),
        options: o['options'] ? getMultiAssistantRequestOptionsFromJson(o['options']) : undefined,
    };
}
export function getMultiAssistantRequestOptionsToJson(m) {
    const o = {};
    if (m.skipGoalsHydration !== undefined)
        o['skipGoalsHydration'] = m.skipGoalsHydration;
    return o;
}
export function getMultiAssistantRequestOptionsFromJson(o) {
    var _a;
    return {
        skipGoalsHydration: (_a = o['skipGoalsHydration']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getMultiAssistantResponseToJson(m) {
    const o = {};
    if (m.assistants !== undefined) {
        o['assistants'] = m.assistants.map(e => assistantToJson(e));
    }
    return o;
}
export function getMultiAssistantResponseFromJson(o) {
    var _a;
    return {
        assistants: ((_a = o['assistants']) !== null && _a !== void 0 ? _a : []).map(e => assistantFromJson(e)),
    };
}
export function batchCheckAssistantScopesRequestToJson(m) {
    const o = {};
    if (m.assistantKeys !== undefined) {
        o['assistantKeys'] = m.assistantKeys.map(e => assistantKeyToJson(e));
    }
    return o;
}
export function batchCheckAssistantScopesRequestFromJson(o) {
    var _a;
    return {
        assistantKeys: ((_a = o['assistantKeys']) !== null && _a !== void 0 ? _a : []).map(e => assistantKeyFromJson(e)),
    };
}
export function batchCheckAssistantScopesResponseToJson(m) {
    const o = {};
    if (m.entries !== undefined) {
        o['entries'] = m.entries.map(e => assistantScopesToJson(e));
    }
    return o;
}
export function batchCheckAssistantScopesResponseFromJson(o) {
    var _a;
    return {
        entries: ((_a = o['entries']) !== null && _a !== void 0 ? _a : []).map(e => assistantScopesFromJson(e)),
    };
}
export function assistantScopesToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = assistantKeyToJson(m.key);
    if (m.allowedActions !== undefined) {
        o['allowedActions'] = m.allowedActions.map(e => e);
    }
    return o;
}
export function assistantScopesFromJson(o) {
    var _a;
    return {
        key: o['key'] ? assistantKeyFromJson(o['key']) : undefined,
        allowedActions: ((_a = o['allowedActions']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function buildDefaultAssistantRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.type !== undefined)
        o['type'] = m.type;
    return o;
}
export function buildDefaultAssistantRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        type: (_b = o['type']) !== null && _b !== void 0 ? _b : 'ASSISTANT_TYPE_UNSPECIFIED',
    };
}
export function buildDefaultAssistantResponseToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    return o;
}
export function buildDefaultAssistantResponseFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
    };
}
export function deleteAssistantRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function deleteAssistantRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function listAssistantRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listAssistantRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listAssistantRequestFromJson(o) {
    return {
        filters: o['filters'] ? listAssistantRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listAssistantRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.excludedTypes !== undefined) {
        o['excludedTypes'] = m.excludedTypes.map(e => e);
    }
    return o;
}
export function listAssistantRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'ASSISTANT_TYPE_UNSPECIFIED',
        excludedTypes: ((_b = o['excludedTypes']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function listAssistantResponseToJson(m) {
    const o = {};
    if (m.assistants !== undefined) {
        o['assistants'] = m.assistants.map(e => assistantToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listAssistantResponseFromJson(o) {
    var _a;
    return {
        assistants: ((_a = o['assistants']) !== null && _a !== void 0 ? _a : []).map(e => assistantFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function listAssistantVersionsRequestToJson(m) {
    const o = {};
    if (m.key !== undefined)
        o['key'] = assistantKeyToJson(m.key);
    if (m.filters !== undefined)
        o['filters'] = listAssistantVersionsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listAssistantVersionsRequestFromJson(o) {
    return {
        key: o['key'] ? assistantKeyFromJson(o['key']) : undefined,
        filters: o['filters'] ? listAssistantVersionsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listAssistantVersionsRequestFiltersToJson(m) {
    const o = {};
    if (m.versionType !== undefined)
        o['versionType'] = m.versionType;
    return o;
}
export function listAssistantVersionsRequestFiltersFromJson(o) {
    var _a;
    return {
        versionType: (_a = o['versionType']) !== null && _a !== void 0 ? _a : 'VERSION_TYPE_INVALID',
    };
}
export function listAssistantVersionsResponseToJson(m) {
    const o = {};
    if (m.versions !== undefined) {
        o['versions'] = m.versions.map(e => assistantVersionSummaryToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listAssistantVersionsResponseFromJson(o) {
    var _a;
    return {
        versions: ((_a = o['versions']) !== null && _a !== void 0 ? _a : []).map(e => assistantVersionSummaryFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function getAssistantVersionRequestToJson(m) {
    const o = {};
    if (m.version !== undefined)
        o['version'] = assistantVersionKeyToJson(m.version);
    return o;
}
export function getAssistantVersionRequestFromJson(o) {
    return {
        version: o['version'] ? assistantVersionKeyFromJson(o['version']) : undefined,
    };
}
export function getAssistantVersionResponseToJson(m) {
    const o = {};
    if (m.assistant !== undefined)
        o['assistant'] = assistantToJson(m.assistant);
    return o;
}
export function getAssistantVersionResponseFromJson(o) {
    return {
        assistant: o['assistant'] ? assistantFromJson(o['assistant']) : undefined,
    };
}
export function deleteAssistantVersionRequestToJson(m) {
    const o = {};
    if (m.version !== undefined)
        o['version'] = assistantVersionKeyToJson(m.version);
    return o;
}
export function deleteAssistantVersionRequestFromJson(o) {
    return {
        version: o['version'] ? assistantVersionKeyFromJson(o['version']) : undefined,
    };
}
export function upsertConnectionRequestToJson(m) {
    const o = {};
    if (m.connection !== undefined)
        o['connection'] = connectionToJson(m.connection);
    return o;
}
export function upsertConnectionRequestFromJson(o) {
    return {
        connection: o['connection'] ? connectionFromJson(o['connection']) : undefined,
    };
}
export function getConnectionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.connectionType !== undefined)
        o['connectionType'] = m.connectionType;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.includeAssistantKeys !== undefined)
        o['includeAssistantKeys'] = m.includeAssistantKeys;
    return o;
}
export function getConnectionRequestFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        connectionType: (_b = o['connectionType']) !== null && _b !== void 0 ? _b : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        includeAssistantKeys: (_c = o['includeAssistantKeys']) !== null && _c !== void 0 ? _c : false,
    };
}
export function getConnectionResponseToJson(m) {
    const o = {};
    if (m.connection !== undefined)
        o['connection'] = connectionToJson(m.connection);
    return o;
}
export function getConnectionResponseFromJson(o) {
    return {
        connection: o['connection'] ? connectionFromJson(o['connection']) : undefined,
    };
}
export function deleteConnectionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.connectionType !== undefined)
        o['connectionType'] = m.connectionType;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function deleteConnectionRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        connectionType: (_b = o['connectionType']) !== null && _b !== void 0 ? _b : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function batchSetConnectionAssistantRequestToJson(m) {
    const o = {};
    if (m.connectionKey !== undefined)
        o['connectionKey'] = connectionKeyToJson(m.connectionKey);
    if (m.entries !== undefined) {
        o['entries'] = m.entries.map(e => associationEntryToJson(e));
    }
    return o;
}
export function batchSetConnectionAssistantRequestFromJson(o) {
    var _a;
    return {
        connectionKey: o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined,
        entries: ((_a = o['entries']) !== null && _a !== void 0 ? _a : []).map(e => associationEntryFromJson(e)),
    };
}
export function associationEntryToJson(m) {
    const o = {};
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    if (m.uniqueInstanceId !== undefined)
        o['uniqueInstanceId'] = m.uniqueInstanceId;
    return o;
}
export function associationEntryFromJson(o) {
    var _a;
    return {
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
        uniqueInstanceId: (_a = o['uniqueInstanceId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function batchDeleteAssistantConnectionAssociationsRequestToJson(m) {
    const o = {};
    if (m.connectionKey !== undefined)
        o['connectionKey'] = connectionKeyToJson(m.connectionKey);
    if (m.entries !== undefined) {
        o['entries'] = m.entries.map(e => associationEntryToJson(e));
    }
    return o;
}
export function batchDeleteAssistantConnectionAssociationsRequestFromJson(o) {
    var _a;
    return {
        connectionKey: o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined,
        entries: ((_a = o['entries']) !== null && _a !== void 0 ? _a : []).map(e => associationEntryFromJson(e)),
    };
}
export function listConnectionsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listConnectionsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.includeAssistantKeys !== undefined)
        o['includeAssistantKeys'] = m.includeAssistantKeys;
    return o;
}
export function listConnectionsRequestFromJson(o) {
    var _a;
    return {
        filters: o['filters'] ? listConnectionsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        includeAssistantKeys: (_a = o['includeAssistantKeys']) !== null && _a !== void 0 ? _a : false,
    };
}
export function listConnectionsRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.assistantType !== undefined)
        o['assistantType'] = m.assistantType;
    return o;
}
export function listConnectionsRequestFiltersFromJson(o) {
    var _a;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        assistantType: (_a = o['assistantType']) !== null && _a !== void 0 ? _a : 'ASSISTANT_TYPE_UNSPECIFIED',
    };
}
export function listConnectionsResponseToJson(m) {
    const o = {};
    if (m.connections !== undefined) {
        o['connections'] = m.connections.map(e => connectionToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listConnectionsResponseFromJson(o) {
    var _a;
    return {
        connections: ((_a = o['connections']) !== null && _a !== void 0 ? _a : []).map(e => connectionFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function listAllAssistantsAssociatedToConnectionRequestToJson(m) {
    const o = {};
    if (m.connectionKey !== undefined)
        o['connectionKey'] = connectionKeyToJson(m.connectionKey);
    if (m.filters !== undefined)
        o['filters'] = listAllAssistantsAssociatedToConnectionRequestFiltersToJson(m.filters);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function listAllAssistantsAssociatedToConnectionRequestFromJson(o) {
    return {
        connectionKey: o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined,
        filters: o['filters'] ? listAllAssistantsAssociatedToConnectionRequestFiltersFromJson(o['filters']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function listAllAssistantsAssociatedToConnectionRequestFiltersToJson(m) {
    const o = {};
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.excludedTypes !== undefined) {
        o['excludedTypes'] = m.excludedTypes.map(e => e);
    }
    return o;
}
export function listAllAssistantsAssociatedToConnectionRequestFiltersFromJson(o) {
    var _a, _b;
    return {
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'ASSISTANT_TYPE_UNSPECIFIED',
        excludedTypes: ((_b = o['excludedTypes']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function listAllAssistantsAssociatedToConnectionResponseToJson(m) {
    const o = {};
    if (m.assistants !== undefined) {
        o['assistants'] = m.assistants.map(e => assistantToJson(e));
    }
    return o;
}
export function listAllAssistantsAssociatedToConnectionResponseFromJson(o) {
    var _a;
    return {
        assistants: ((_a = o['assistants']) !== null && _a !== void 0 ? _a : []).map(e => assistantFromJson(e)),
    };
}
export function generateChatAnswerRequestToJson(m) {
    const o = {};
    if (m.connectionKey !== undefined)
        o['connectionKey'] = connectionKeyToJson(m.connectionKey);
    if (m.chatHistory !== undefined) {
        o['chatHistory'] = m.chatHistory.map(e => chatMessageToJson(e));
    }
    if (m.chatUserInfo !== undefined)
        o['chatUserInfo'] = chatUserInfoToJson(m.chatUserInfo);
    if (m.chatChannel !== undefined)
        o['chatChannel'] = m.chatChannel;
    if (m.options !== undefined)
        o['options'] = generateChatAnswerRequestOptionsToJson(m.options);
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    if (m.contextInfo !== undefined)
        o['contextInfo'] = contextInfoToJson(m.contextInfo);
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.invocationContext !== undefined)
        o['invocationContext'] = invocationContextToJson(m.invocationContext);
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    return o;
}
export function generateChatAnswerRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        connectionKey: o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined,
        chatHistory: ((_a = o['chatHistory']) !== null && _a !== void 0 ? _a : []).map(e => chatMessageFromJson(e)),
        chatUserInfo: o['chatUserInfo'] ? chatUserInfoFromJson(o['chatUserInfo']) : undefined,
        chatChannel: (_b = o['chatChannel']) !== null && _b !== void 0 ? _b : 'CHAT_CHANNEL_INVALID',
        options: o['options'] ? generateChatAnswerRequestOptionsFromJson(o['options']) : undefined,
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
        contextInfo: o['contextInfo'] ? contextInfoFromJson(o['contextInfo']) : undefined,
        sessionId: (_c = o['sessionId']) !== null && _c !== void 0 ? _c : '',
        invocationContext: o['invocationContext'] ? invocationContextFromJson(o['invocationContext']) : undefined,
        tags: ((_d = o['tags']) !== null && _d !== void 0 ? _d : []).map(e => e),
    };
}
export function generateChatAnswerRequestOptionsToJson(m) {
    const o = {};
    if (m.includeAllCitations !== undefined)
        o['includeAllCitations'] = m.includeAllCitations;
    if (m.enableAsyncFunctions !== undefined)
        o['enableAsyncFunctions'] = m.enableAsyncFunctions;
    if (m.maxTokens !== undefined)
        o['maxTokens'] = m.maxTokens;
    return o;
}
export function generateChatAnswerRequestOptionsFromJson(o) {
    var _a, _b, _c;
    return {
        includeAllCitations: (_a = o['includeAllCitations']) !== null && _a !== void 0 ? _a : false,
        enableAsyncFunctions: (_b = o['enableAsyncFunctions']) !== null && _b !== void 0 ? _b : false,
        maxTokens: (_c = o['maxTokens']) !== null && _c !== void 0 ? _c : 0,
    };
}
export function generateChatAnswerResponseToJson(m) {
    const o = {};
    if (m.answer !== undefined)
        o['answer'] = m.answer;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.pendingJobId !== undefined)
        o['pendingJobId'] = m.pendingJobId;
    if (m.validationResult !== undefined)
        o['validationResult'] = validationResultToJson(m.validationResult);
    if (m.toolCalls !== undefined) {
        o['toolCalls'] = m.toolCalls.map(e => toolCallToJson(e));
    }
    if (m.reasoning !== undefined)
        o['reasoning'] = m.reasoning;
    if (m.citations !== undefined) {
        o['citations'] = m.citations.map(e => answerCitationToJson(e));
    }
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.proposedActionEventId !== undefined)
        o['proposedActionEventId'] = m.proposedActionEventId;
    if (m.attachments !== undefined) {
        o['attachments'] = m.attachments.map(e => attachmentToJson(e));
    }
    return o;
}
export function generateChatAnswerResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        answer: (_a = o['answer']) !== null && _a !== void 0 ? _a : '',
        metadata: ((_b = o['metadata']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
        pendingJobId: (_c = o['pendingJobId']) !== null && _c !== void 0 ? _c : '',
        validationResult: o['validationResult'] ? validationResultFromJson(o['validationResult']) : undefined,
        toolCalls: ((_d = o['toolCalls']) !== null && _d !== void 0 ? _d : []).map(e => toolCallFromJson(e)),
        reasoning: (_e = o['reasoning']) !== null && _e !== void 0 ? _e : '',
        citations: ((_f = o['citations']) !== null && _f !== void 0 ? _f : []).map(e => answerCitationFromJson(e)),
        sessionId: (_g = o['sessionId']) !== null && _g !== void 0 ? _g : '',
        proposedActionEventId: (_h = o['proposedActionEventId']) !== null && _h !== void 0 ? _h : '',
        attachments: ((_j = o['attachments']) !== null && _j !== void 0 ? _j : []).map(e => attachmentFromJson(e)),
    };
}
export function validationViolationToJson(m) {
    const o = {};
    if (m.failureAction !== undefined)
        o['failureAction'] = m.failureAction;
    if (m.confidence !== undefined)
        o['confidence'] = m.confidence;
    if (m.message !== undefined)
        o['message'] = m.message;
    if (m.validatorName !== undefined)
        o['validatorName'] = m.validatorName;
    if (m.isInputValidation !== undefined)
        o['isInputValidation'] = m.isInputValidation;
    return o;
}
export function validationViolationFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        failureAction: (_a = o['failureAction']) !== null && _a !== void 0 ? _a : 'VALIDATION_FAILURE_ACTION_UNSPECIFIED',
        confidence: (_b = o['confidence']) !== null && _b !== void 0 ? _b : 0,
        message: (_c = o['message']) !== null && _c !== void 0 ? _c : '',
        validatorName: (_d = o['validatorName']) !== null && _d !== void 0 ? _d : '',
        isInputValidation: (_e = o['isInputValidation']) !== null && _e !== void 0 ? _e : false,
    };
}
export function validationResultToJson(m) {
    const o = {};
    if (m.failureAction !== undefined)
        o['failureAction'] = m.failureAction;
    if (m.violations !== undefined) {
        o['violations'] = m.violations.map(e => validationViolationToJson(e));
    }
    return o;
}
export function validationResultFromJson(o) {
    var _a, _b;
    return {
        failureAction: (_a = o['failureAction']) !== null && _a !== void 0 ? _a : 'VALIDATION_FAILURE_ACTION_UNSPECIFIED',
        violations: ((_b = o['violations']) !== null && _b !== void 0 ? _b : []).map(e => validationViolationFromJson(e)),
    };
}
export function streamingGenerateChatAnswerRequestToJson(m) {
    const o = {};
    if (m.chatHistory !== undefined) {
        o['chatHistory'] = m.chatHistory.map(e => chatMessageToJson(e));
    }
    if (m.chatUserInfo !== undefined)
        o['chatUserInfo'] = chatUserInfoToJson(m.chatUserInfo);
    if (m.chatChannel !== undefined)
        o['chatChannel'] = m.chatChannel;
    if (m.contextInfo !== undefined)
        o['contextInfo'] = contextInfoToJson(m.contextInfo);
    if (m.agentArchitecture !== undefined)
        o['agentArchitecture'] = m.agentArchitecture;
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.invocationContext !== undefined)
        o['invocationContext'] = invocationContextToJson(m.invocationContext);
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    if (m.target !== undefined) {
        if (m.target.type === 'connectionKey') {
            o['connectionKey'] = connectionKeyToJson(m.target.connectionKey);
        }
        if (m.target.type === 'assistantKey') {
            o['assistantKey'] = assistantKeyToJson(m.target.assistantKey);
        }
    }
    else {
        if (m.connectionKey !== undefined)
            o['connectionKey'] = connectionKeyToJson(m.connectionKey);
        if (m.assistantKey !== undefined)
            o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    }
    return o;
}
export function streamingGenerateChatAnswerRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        chatHistory: ((_a = o['chatHistory']) !== null && _a !== void 0 ? _a : []).map(e => chatMessageFromJson(e)),
        chatUserInfo: o['chatUserInfo'] ? chatUserInfoFromJson(o['chatUserInfo']) : undefined,
        chatChannel: (_b = o['chatChannel']) !== null && _b !== void 0 ? _b : 'CHAT_CHANNEL_INVALID',
        contextInfo: o['contextInfo'] ? contextInfoFromJson(o['contextInfo']) : undefined,
        agentArchitecture: (_c = o['agentArchitecture']) !== null && _c !== void 0 ? _c : 'UNSET',
        sessionId: (_d = o['sessionId']) !== null && _d !== void 0 ? _d : '',
        invocationContext: o['invocationContext'] ? invocationContextFromJson(o['invocationContext']) : undefined,
        tags: ((_e = o['tags']) !== null && _e !== void 0 ? _e : []).map(e => e),
        target: (() => {
            if (o['connectionKey'] !== undefined)
                return { type: 'connectionKey', connectionKey: o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined };
            if (o['assistantKey'] !== undefined)
                return { type: 'assistantKey', assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined };
            return undefined;
        })(),
        connectionKey: o['connectionKey'] !== undefined ? o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined : undefined,
        assistantKey: o['assistantKey'] !== undefined ? o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined : undefined,
    };
}
export function resumeStreamingGenerateChatAnswerRequestToJson(m) {
    const o = {};
    if (m.streamId !== undefined)
        o['streamId'] = m.streamId;
    if (m.lastReceivedSequenceNumber !== undefined)
        o['lastReceivedSequenceNumber'] = m.lastReceivedSequenceNumber;
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    return o;
}
export function resumeStreamingGenerateChatAnswerRequestFromJson(o) {
    var _a, _b, _c;
    return {
        streamId: (_a = o['streamId']) !== null && _a !== void 0 ? _a : '',
        lastReceivedSequenceNumber: (_b = o['lastReceivedSequenceNumber']) !== null && _b !== void 0 ? _b : 0,
        sessionId: (_c = o['sessionId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function streamingGenerateChatAnswerResponseToJson(m) {
    const o = {};
    if (m.sequenceNumber !== undefined)
        o['sequenceNumber'] = m.sequenceNumber;
    if (m.chunk !== undefined) {
        if (m.chunk.type === 'start') {
            o['start'] = streamingGenerateChatAnswerResponseStartChunkToJson(m.chunk.start);
        }
        if (m.chunk.type === 'content') {
            o['content'] = streamingGenerateChatAnswerResponseContentChunkToJson(m.chunk.content);
        }
        if (m.chunk.type === 'metadata') {
            o['metadata'] = streamingGenerateChatAnswerResponseMetadataChunkToJson(m.chunk.metadata);
        }
        if (m.chunk.type === 'functionStart') {
            o['functionStart'] = streamingGenerateChatAnswerResponseFunctionStartChunkToJson(m.chunk.functionStart);
        }
        if (m.chunk.type === 'functionProgress') {
            o['functionProgress'] = streamingGenerateChatAnswerResponseFunctionProgressChunkToJson(m.chunk.functionProgress);
        }
        if (m.chunk.type === 'functionComplete') {
            o['functionComplete'] = streamingGenerateChatAnswerResponseFunctionCompleteChunkToJson(m.chunk.functionComplete);
        }
        if (m.chunk.type === 'final') {
            o['final'] = streamingGenerateChatAnswerResponseFinalChunkToJson(m.chunk.final);
        }
        if (m.chunk.type === 'error') {
            o['error'] = streamingGenerateChatAnswerResponseErrorChunkToJson(m.chunk.error);
        }
        if (m.chunk.type === 'inputValidation') {
            o['inputValidation'] = streamingGenerateChatAnswerResponseValidationChunkToJson(m.chunk.inputValidation);
        }
        if (m.chunk.type === 'proposedAction') {
            o['proposedAction'] = streamingGenerateChatAnswerResponseProposedActionChunkToJson(m.chunk.proposedAction);
        }
    }
    else {
        if (m.start !== undefined)
            o['start'] = streamingGenerateChatAnswerResponseStartChunkToJson(m.start);
        if (m.content !== undefined)
            o['content'] = streamingGenerateChatAnswerResponseContentChunkToJson(m.content);
        if (m.metadata !== undefined)
            o['metadata'] = streamingGenerateChatAnswerResponseMetadataChunkToJson(m.metadata);
        if (m.functionStart !== undefined)
            o['functionStart'] = streamingGenerateChatAnswerResponseFunctionStartChunkToJson(m.functionStart);
        if (m.functionProgress !== undefined)
            o['functionProgress'] = streamingGenerateChatAnswerResponseFunctionProgressChunkToJson(m.functionProgress);
        if (m.functionComplete !== undefined)
            o['functionComplete'] = streamingGenerateChatAnswerResponseFunctionCompleteChunkToJson(m.functionComplete);
        if (m.final !== undefined)
            o['final'] = streamingGenerateChatAnswerResponseFinalChunkToJson(m.final);
        if (m.error !== undefined)
            o['error'] = streamingGenerateChatAnswerResponseErrorChunkToJson(m.error);
        if (m.inputValidation !== undefined)
            o['inputValidation'] = streamingGenerateChatAnswerResponseValidationChunkToJson(m.inputValidation);
        if (m.proposedAction !== undefined)
            o['proposedAction'] = streamingGenerateChatAnswerResponseProposedActionChunkToJson(m.proposedAction);
    }
    return o;
}
export function streamingGenerateChatAnswerResponseFromJson(o) {
    var _a;
    return {
        sequenceNumber: (_a = o['sequenceNumber']) !== null && _a !== void 0 ? _a : 0,
        chunk: (() => {
            if (o['start'] !== undefined)
                return { type: 'start', start: o['start'] ? streamingGenerateChatAnswerResponseStartChunkFromJson(o['start']) : undefined };
            if (o['content'] !== undefined)
                return { type: 'content', content: o['content'] ? streamingGenerateChatAnswerResponseContentChunkFromJson(o['content']) : undefined };
            if (o['metadata'] !== undefined)
                return { type: 'metadata', metadata: o['metadata'] ? streamingGenerateChatAnswerResponseMetadataChunkFromJson(o['metadata']) : undefined };
            if (o['functionStart'] !== undefined)
                return { type: 'functionStart', functionStart: o['functionStart'] ? streamingGenerateChatAnswerResponseFunctionStartChunkFromJson(o['functionStart']) : undefined };
            if (o['functionProgress'] !== undefined)
                return { type: 'functionProgress', functionProgress: o['functionProgress'] ? streamingGenerateChatAnswerResponseFunctionProgressChunkFromJson(o['functionProgress']) : undefined };
            if (o['functionComplete'] !== undefined)
                return { type: 'functionComplete', functionComplete: o['functionComplete'] ? streamingGenerateChatAnswerResponseFunctionCompleteChunkFromJson(o['functionComplete']) : undefined };
            if (o['final'] !== undefined)
                return { type: 'final', final: o['final'] ? streamingGenerateChatAnswerResponseFinalChunkFromJson(o['final']) : undefined };
            if (o['error'] !== undefined)
                return { type: 'error', error: o['error'] ? streamingGenerateChatAnswerResponseErrorChunkFromJson(o['error']) : undefined };
            if (o['inputValidation'] !== undefined)
                return { type: 'inputValidation', inputValidation: o['inputValidation'] ? streamingGenerateChatAnswerResponseValidationChunkFromJson(o['inputValidation']) : undefined };
            if (o['proposedAction'] !== undefined)
                return { type: 'proposedAction', proposedAction: o['proposedAction'] ? streamingGenerateChatAnswerResponseProposedActionChunkFromJson(o['proposedAction']) : undefined };
            return undefined;
        })(),
        start: o['start'] !== undefined ? o['start'] ? streamingGenerateChatAnswerResponseStartChunkFromJson(o['start']) : undefined : undefined,
        content: o['content'] !== undefined ? o['content'] ? streamingGenerateChatAnswerResponseContentChunkFromJson(o['content']) : undefined : undefined,
        metadata: o['metadata'] !== undefined ? o['metadata'] ? streamingGenerateChatAnswerResponseMetadataChunkFromJson(o['metadata']) : undefined : undefined,
        functionStart: o['functionStart'] !== undefined ? o['functionStart'] ? streamingGenerateChatAnswerResponseFunctionStartChunkFromJson(o['functionStart']) : undefined : undefined,
        functionProgress: o['functionProgress'] !== undefined ? o['functionProgress'] ? streamingGenerateChatAnswerResponseFunctionProgressChunkFromJson(o['functionProgress']) : undefined : undefined,
        functionComplete: o['functionComplete'] !== undefined ? o['functionComplete'] ? streamingGenerateChatAnswerResponseFunctionCompleteChunkFromJson(o['functionComplete']) : undefined : undefined,
        final: o['final'] !== undefined ? o['final'] ? streamingGenerateChatAnswerResponseFinalChunkFromJson(o['final']) : undefined : undefined,
        error: o['error'] !== undefined ? o['error'] ? streamingGenerateChatAnswerResponseErrorChunkFromJson(o['error']) : undefined : undefined,
        inputValidation: o['inputValidation'] !== undefined ? o['inputValidation'] ? streamingGenerateChatAnswerResponseValidationChunkFromJson(o['inputValidation']) : undefined : undefined,
        proposedAction: o['proposedAction'] !== undefined ? o['proposedAction'] ? streamingGenerateChatAnswerResponseProposedActionChunkFromJson(o['proposedAction']) : undefined : undefined,
    };
}
export function streamingGenerateChatAnswerResponseStartChunkToJson(m) {
    const o = {};
    if (m.streamId !== undefined)
        o['streamId'] = m.streamId;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    return o;
}
export function streamingGenerateChatAnswerResponseStartChunkFromJson(o) {
    var _a, _b, _c;
    return {
        streamId: (_a = o['streamId']) !== null && _a !== void 0 ? _a : '',
        metadata: ((_b = o['metadata']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
        sessionId: (_c = o['sessionId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function streamingGenerateChatAnswerResponseValidationChunkToJson(m) {
    const o = {};
    if (m.validationResult !== undefined)
        o['validationResult'] = validationResultToJson(m.validationResult);
    return o;
}
export function streamingGenerateChatAnswerResponseValidationChunkFromJson(o) {
    return {
        validationResult: o['validationResult'] ? validationResultFromJson(o['validationResult']) : undefined,
    };
}
export function streamingGenerateChatAnswerResponseContentChunkToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.contentType !== undefined)
        o['contentType'] = m.contentType;
    if (m.validationResult !== undefined)
        o['validationResult'] = validationResultToJson(m.validationResult);
    if (m.sessionEventId !== undefined)
        o['sessionEventId'] = m.sessionEventId;
    if (m.attachment !== undefined)
        o['attachment'] = attachmentToJson(m.attachment);
    return o;
}
export function streamingGenerateChatAnswerResponseContentChunkFromJson(o) {
    var _a, _b, _c;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
        contentType: (_b = o['contentType']) !== null && _b !== void 0 ? _b : 'CONTENT_TYPE_UNSPECIFIED',
        validationResult: o['validationResult'] ? validationResultFromJson(o['validationResult']) : undefined,
        sessionEventId: (_c = o['sessionEventId']) !== null && _c !== void 0 ? _c : '',
        attachment: o['attachment'] ? attachmentFromJson(o['attachment']) : undefined,
    };
}
export function streamingGenerateChatAnswerResponseMetadataChunkToJson(m) {
    const o = {};
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.citations !== undefined) {
        o['citations'] = m.citations.map(e => answerCitationToJson(e));
    }
    if (m.attachments !== undefined) {
        o['attachments'] = m.attachments.map(e => attachmentToJson(e));
    }
    return o;
}
export function streamingGenerateChatAnswerResponseMetadataChunkFromJson(o) {
    var _a, _b, _c;
    return {
        metadata: ((_a = o['metadata']) !== null && _a !== void 0 ? _a : []).map(e => keyValuePairFromJson(e)),
        citations: ((_b = o['citations']) !== null && _b !== void 0 ? _b : []).map(e => answerCitationFromJson(e)),
        attachments: ((_c = o['attachments']) !== null && _c !== void 0 ? _c : []).map(e => attachmentFromJson(e)),
    };
}
export function streamingGenerateChatAnswerResponseFunctionStartChunkToJson(m) {
    const o = {};
    if (m.functionName !== undefined)
        o['functionName'] = m.functionName;
    if (m.functionDescription !== undefined)
        o['functionDescription'] = m.functionDescription;
    if (m.arguments !== undefined)
        o['arguments'] = m.arguments;
    if (m.functionCallId !== undefined)
        o['functionCallId'] = m.functionCallId;
    if (m.noOp !== undefined)
        o['noOp'] = m.noOp;
    if (m.sessionEventId !== undefined)
        o['sessionEventId'] = m.sessionEventId;
    if (m.namespaceType !== undefined)
        o['namespaceType'] = m.namespaceType;
    if (m.namespaceId !== undefined)
        o['namespaceId'] = m.namespaceId;
    return o;
}
export function streamingGenerateChatAnswerResponseFunctionStartChunkFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        functionName: (_a = o['functionName']) !== null && _a !== void 0 ? _a : '',
        functionDescription: (_b = o['functionDescription']) !== null && _b !== void 0 ? _b : '',
        arguments: (_c = o['arguments']) !== null && _c !== void 0 ? _c : '',
        functionCallId: (_d = o['functionCallId']) !== null && _d !== void 0 ? _d : '',
        noOp: (_e = o['noOp']) !== null && _e !== void 0 ? _e : false,
        sessionEventId: (_f = o['sessionEventId']) !== null && _f !== void 0 ? _f : '',
        namespaceType: (_g = o['namespaceType']) !== null && _g !== void 0 ? _g : '',
        namespaceId: (_h = o['namespaceId']) !== null && _h !== void 0 ? _h : '',
    };
}
export function streamingGenerateChatAnswerResponseFunctionProgressChunkToJson(m) {
    const o = {};
    if (m.functionName !== undefined)
        o['functionName'] = m.functionName;
    if (m.status !== undefined)
        o['status'] = m.status;
    if (m.progressMessage !== undefined)
        o['progressMessage'] = m.progressMessage;
    if (m.functionCallId !== undefined)
        o['functionCallId'] = m.functionCallId;
    return o;
}
export function streamingGenerateChatAnswerResponseFunctionProgressChunkFromJson(o) {
    var _a, _b, _c, _d;
    return {
        functionName: (_a = o['functionName']) !== null && _a !== void 0 ? _a : '',
        status: (_b = o['status']) !== null && _b !== void 0 ? _b : '',
        progressMessage: (_c = o['progressMessage']) !== null && _c !== void 0 ? _c : '',
        functionCallId: (_d = o['functionCallId']) !== null && _d !== void 0 ? _d : '',
    };
}
export function streamingGenerateChatAnswerResponseFunctionCompleteChunkToJson(m) {
    const o = {};
    if (m.functionName !== undefined)
        o['functionName'] = m.functionName;
    if (m.result !== undefined)
        o['result'] = m.result;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    if (m.functionCallId !== undefined)
        o['functionCallId'] = m.functionCallId;
    if (m.latency !== undefined)
        o['latency'] = m.latency;
    if (m.noOp !== undefined)
        o['noOp'] = m.noOp;
    if (m.sessionEventId !== undefined)
        o['sessionEventId'] = m.sessionEventId;
    if (m.namespaceType !== undefined)
        o['namespaceType'] = m.namespaceType;
    if (m.namespaceId !== undefined)
        o['namespaceId'] = m.namespaceId;
    return o;
}
export function streamingGenerateChatAnswerResponseFunctionCompleteChunkFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        functionName: (_a = o['functionName']) !== null && _a !== void 0 ? _a : '',
        result: (_b = o['result']) !== null && _b !== void 0 ? _b : '',
        metadata: ((_c = o['metadata']) !== null && _c !== void 0 ? _c : []).map(e => keyValuePairFromJson(e)),
        functionCallId: (_d = o['functionCallId']) !== null && _d !== void 0 ? _d : '',
        latency: (_e = o['latency']) !== null && _e !== void 0 ? _e : '',
        noOp: (_f = o['noOp']) !== null && _f !== void 0 ? _f : false,
        sessionEventId: (_g = o['sessionEventId']) !== null && _g !== void 0 ? _g : '',
        namespaceType: (_h = o['namespaceType']) !== null && _h !== void 0 ? _h : '',
        namespaceId: (_j = o['namespaceId']) !== null && _j !== void 0 ? _j : '',
    };
}
export function streamingGenerateChatAnswerResponseFinalChunkToJson(m) {
    const o = {};
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    return o;
}
export function streamingGenerateChatAnswerResponseFinalChunkFromJson(o) {
    var _a;
    return {
        sessionId: (_a = o['sessionId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function streamingGenerateChatAnswerResponseErrorChunkToJson(m) {
    const o = {};
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    if (m.errorCode !== undefined)
        o['errorCode'] = m.errorCode;
    if (m.errorDetails !== undefined) {
        o['errorDetails'] = m.errorDetails.map(e => keyValuePairToJson(e));
    }
    if (m.resumable !== undefined)
        o['resumable'] = m.resumable;
    return o;
}
export function streamingGenerateChatAnswerResponseErrorChunkFromJson(o) {
    var _a, _b, _c, _d;
    return {
        errorMessage: (_a = o['errorMessage']) !== null && _a !== void 0 ? _a : '',
        errorCode: (_b = o['errorCode']) !== null && _b !== void 0 ? _b : '',
        errorDetails: ((_c = o['errorDetails']) !== null && _c !== void 0 ? _c : []).map(e => keyValuePairFromJson(e)),
        resumable: (_d = o['resumable']) !== null && _d !== void 0 ? _d : false,
    };
}
export function streamingGenerateChatAnswerResponseProposedActionChunkToJson(m) {
    const o = {};
    if (m.sessionEventId !== undefined)
        o['sessionEventId'] = m.sessionEventId;
    if (m.namespaceType !== undefined)
        o['namespaceType'] = m.namespaceType;
    if (m.namespaceId !== undefined)
        o['namespaceId'] = m.namespaceId;
    return o;
}
export function streamingGenerateChatAnswerResponseProposedActionChunkFromJson(o) {
    var _a, _b, _c;
    return {
        sessionEventId: (_a = o['sessionEventId']) !== null && _a !== void 0 ? _a : '',
        namespaceType: (_b = o['namespaceType']) !== null && _b !== void 0 ? _b : '',
        namespaceId: (_c = o['namespaceId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getChatAnswerFunctionExecutionJobRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function getChatAnswerFunctionExecutionJobRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getChatAnswerFunctionExecutionJobResponseToJson(m) {
    const o = {};
    if (m.job !== undefined)
        o['job'] = chatAnswerFunctionExecutionJobToJson(m.job);
    return o;
}
export function getChatAnswerFunctionExecutionJobResponseFromJson(o) {
    return {
        job: o['job'] ? chatAnswerFunctionExecutionJobFromJson(o['job']) : undefined,
    };
}
export function setAssistantConnectionsRequestToJson(m) {
    const o = {};
    if (m.associationStates !== undefined) {
        o['associationStates'] = m.associationStates.map(e => setAssistantConnectionsRequestConnectionStateToJson(e));
    }
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    return o;
}
export function setAssistantConnectionsRequestFromJson(o) {
    var _a;
    return {
        associationStates: ((_a = o['associationStates']) !== null && _a !== void 0 ? _a : []).map(e => setAssistantConnectionsRequestConnectionStateFromJson(e)),
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
    };
}
export function setAssistantConnectionsRequestConnectionStateToJson(m) {
    const o = {};
    if (m.connectionKey !== undefined)
        o['connectionKey'] = connectionKeyToJson(m.connectionKey);
    if (m.isAssociated !== undefined)
        o['isAssociated'] = m.isAssociated;
    return o;
}
export function setAssistantConnectionsRequestConnectionStateFromJson(o) {
    var _a;
    return {
        connectionKey: o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined,
        isAssociated: (_a = o['isAssociated']) !== null && _a !== void 0 ? _a : false,
    };
}
export function setConnectionAssistantRequestToJson(m) {
    const o = {};
    if (m.connectionKey !== undefined)
        o['connectionKey'] = connectionKeyToJson(m.connectionKey);
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    return o;
}
export function setConnectionAssistantRequestFromJson(o) {
    return {
        connectionKey: o['connectionKey'] ? connectionKeyFromJson(o['connectionKey']) : undefined,
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
    };
}
export function executeFunctionRequestToJson(m) {
    const o = {};
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    if (m.functionKey !== undefined)
        o['functionKey'] = functionKeyToJson(m.functionKey);
    if (m.arguments !== undefined)
        o['arguments'] = m.arguments;
    if (m.options !== undefined)
        o['options'] = executeFunctionRequestOptionsToJson(m.options);
    return o;
}
export function executeFunctionRequestFromJson(o) {
    var _a;
    return {
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
        functionKey: o['functionKey'] ? functionKeyFromJson(o['functionKey']) : undefined,
        arguments: (_a = o['arguments']) !== null && _a !== void 0 ? _a : '',
        options: o['options'] ? executeFunctionRequestOptionsFromJson(o['options']) : undefined,
    };
}
export function executeFunctionRequestOptionsToJson(m) {
    const o = {};
    if (m.skipComputeTemplateVariables !== undefined)
        o['skipComputeTemplateVariables'] = m.skipComputeTemplateVariables;
    if (m.contextInfo !== undefined)
        o['contextInfo'] = contextInfoToJson(m.contextInfo);
    return o;
}
export function executeFunctionRequestOptionsFromJson(o) {
    var _a;
    return {
        skipComputeTemplateVariables: (_a = o['skipComputeTemplateVariables']) !== null && _a !== void 0 ? _a : false,
        contextInfo: o['contextInfo'] ? contextInfoFromJson(o['contextInfo']) : undefined,
    };
}
export function executeFunctionResponseToJson(m) {
    const o = {};
    if (m.output !== undefined)
        o['output'] = m.output;
    if (m.metadata !== undefined) {
        o['metadata'] = m.metadata.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function executeFunctionResponseFromJson(o) {
    var _a, _b;
    return {
        output: (_a = o['output']) !== null && _a !== void 0 ? _a : '',
        metadata: ((_b = o['metadata']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
    };
}
export function listAvailableModelsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listAvailableModelsRequestFiltersToJson(m.filters);
    return o;
}
export function listAvailableModelsRequestFromJson(o) {
    return {
        filters: o['filters'] ? listAvailableModelsRequestFiltersFromJson(o['filters']) : undefined,
    };
}
export function listAvailableModelsRequestFiltersToJson(m) {
    const o = {};
    if (m.vendor !== undefined) {
        o['vendor'] = m.vendor.map(e => e);
    }
    if (m.type !== undefined) {
        o['type'] = m.type.map(e => e);
    }
    if (m.assistantType !== undefined)
        o['assistantType'] = m.assistantType;
    return o;
}
export function listAvailableModelsRequestFiltersFromJson(o) {
    var _a, _b, _c;
    return {
        vendor: ((_a = o['vendor']) !== null && _a !== void 0 ? _a : []).map(e => e),
        type: ((_b = o['type']) !== null && _b !== void 0 ? _b : []).map(e => e),
        assistantType: (_c = o['assistantType']) !== null && _c !== void 0 ? _c : 'ASSISTANT_TYPE_UNSPECIFIED',
    };
}
export function listAvailableModelsResponseToJson(m) {
    const o = {};
    if (m.models !== undefined) {
        o['models'] = m.models.map(e => modelToJson(e));
    }
    return o;
}
export function listAvailableModelsResponseFromJson(o) {
    var _a;
    return {
        models: ((_a = o['models']) !== null && _a !== void 0 ? _a : []).map(e => modelFromJson(e)),
    };
}
export function listTemplateVariablesRequestToJson(m) {
    const o = {};
    if (m.assistantKey !== undefined)
        o['assistantKey'] = assistantKeyToJson(m.assistantKey);
    if (m.chatUserInfo !== undefined)
        o['chatUserInfo'] = chatUserInfoToJson(m.chatUserInfo);
    if (m.invocationContext !== undefined)
        o['invocationContext'] = invocationContextToJson(m.invocationContext);
    return o;
}
export function listTemplateVariablesRequestFromJson(o) {
    return {
        assistantKey: o['assistantKey'] ? assistantKeyFromJson(o['assistantKey']) : undefined,
        chatUserInfo: o['chatUserInfo'] ? chatUserInfoFromJson(o['chatUserInfo']) : undefined,
        invocationContext: o['invocationContext'] ? invocationContextFromJson(o['invocationContext']) : undefined,
    };
}
export function listTemplateVariablesResponseToJson(m) {
    const o = {};
    if (m.assistantScopedVariables !== undefined) {
        o['assistantScopedVariables'] = m.assistantScopedVariables.map(e => templateVariableToJson(e));
    }
    return o;
}
export function listTemplateVariablesResponseFromJson(o) {
    var _a;
    return {
        assistantScopedVariables: ((_a = o['assistantScopedVariables']) !== null && _a !== void 0 ? _a : []).map(e => templateVariableFromJson(e)),
    };
}
export function createPromptModuleRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.managed !== undefined)
        o['managed'] = m.managed;
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    return o;
}
export function createPromptModuleRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        content: (_d = o['content']) !== null && _d !== void 0 ? _d : '',
        managed: (_e = o['managed']) !== null && _e !== void 0 ? _e : false,
        sourcePath: (_f = o['sourcePath']) !== null && _f !== void 0 ? _f : '',
    };
}
export function createPromptModuleResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function createPromptModuleResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function createPromptModuleVersionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.content !== undefined)
        o['content'] = m.content;
    if (m.options !== undefined)
        o['options'] = createPromptModuleVersionRequestOptionsToJson(m.options);
    return o;
}
export function createPromptModuleVersionRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        content: (_b = o['content']) !== null && _b !== void 0 ? _b : '',
        options: o['options'] ? createPromptModuleVersionRequestOptionsFromJson(o['options']) : undefined,
    };
}
export function createPromptModuleVersionRequestOptionsToJson(m) {
    const o = {};
    if (m.shouldDeploy !== undefined)
        o['shouldDeploy'] = m.shouldDeploy;
    return o;
}
export function createPromptModuleVersionRequestOptionsFromJson(o) {
    var _a;
    return {
        shouldDeploy: (_a = o['shouldDeploy']) !== null && _a !== void 0 ? _a : false,
    };
}
export function getPromptModuleRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getPromptModuleRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getPromptModuleResponseToJson(m) {
    const o = {};
    if (m.promptModule !== undefined)
        o['promptModule'] = promptModuleToJson(m.promptModule);
    return o;
}
export function getPromptModuleResponseFromJson(o) {
    return {
        promptModule: o['promptModule'] ? promptModuleFromJson(o['promptModule']) : undefined,
    };
}
export function getPromptModuleVersionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.version !== undefined)
        o['version'] = m.version;
    return o;
}
export function getPromptModuleVersionRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        version: (_b = o['version']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getPromptModuleVersionResponseToJson(m) {
    const o = {};
    if (m.promptModuleVersion !== undefined)
        o['promptModuleVersion'] = promptModuleVersionToJson(m.promptModuleVersion);
    return o;
}
export function getPromptModuleVersionResponseFromJson(o) {
    return {
        promptModuleVersion: o['promptModuleVersion'] ? promptModuleVersionFromJson(o['promptModuleVersion']) : undefined,
    };
}
export function getDeployedPromptModuleVersionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getDeployedPromptModuleVersionRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getDeployedPromptModuleVersionResponseToJson(m) {
    const o = {};
    if (m.promptModule !== undefined)
        o['promptModule'] = promptModuleToJson(m.promptModule);
    if (m.deployedPromptModuleVersion !== undefined)
        o['deployedPromptModuleVersion'] = promptModuleVersionToJson(m.deployedPromptModuleVersion);
    return o;
}
export function getDeployedPromptModuleVersionResponseFromJson(o) {
    return {
        promptModule: o['promptModule'] ? promptModuleFromJson(o['promptModule']) : undefined,
        deployedPromptModuleVersion: o['deployedPromptModuleVersion'] ? promptModuleVersionFromJson(o['deployedPromptModuleVersion']) : undefined,
    };
}
export function getHydratedDeployedPromptModuleVersionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.variables !== undefined) {
        o['variables'] = m.variables.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function getHydratedDeployedPromptModuleVersionRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        variables: ((_b = o['variables']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
    };
}
export function getHydratedDeployedPromptModuleVersionResponseToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function getHydratedDeployedPromptModuleVersionResponseFromJson(o) {
    var _a;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getMultiHydratedDeployedPromptModuleVersionRequestToJson(m) {
    const o = {};
    if (m.keys !== undefined) {
        o['keys'] = m.keys.map(e => promptModuleKeyToJson(e));
    }
    if (m.variables !== undefined) {
        o['variables'] = m.variables.map(e => keyValuePairToJson(e));
    }
    return o;
}
export function getMultiHydratedDeployedPromptModuleVersionRequestFromJson(o) {
    var _a, _b;
    return {
        keys: ((_a = o['keys']) !== null && _a !== void 0 ? _a : []).map(e => promptModuleKeyFromJson(e)),
        variables: ((_b = o['variables']) !== null && _b !== void 0 ? _b : []).map(e => keyValuePairFromJson(e)),
    };
}
export function getMultiHydratedDeployedPromptModuleVersionResponseToJson(m) {
    const o = {};
    if (m.contents !== undefined) {
        o['contents'] = m.contents.map(e => e);
    }
    return o;
}
export function getMultiHydratedDeployedPromptModuleVersionResponseFromJson(o) {
    var _a;
    return {
        contents: ((_a = o['contents']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function updatePromptModuleRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.description !== undefined)
        o['description'] = m.description;
    if (m.sourcePath !== undefined)
        o['sourcePath'] = m.sourcePath;
    return o;
}
export function updatePromptModuleRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        description: (_c = o['description']) !== null && _c !== void 0 ? _c : '',
        sourcePath: (_d = o['sourcePath']) !== null && _d !== void 0 ? _d : '',
    };
}
export function deployPromptModuleRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.version !== undefined)
        o['version'] = m.version;
    return o;
}
export function deployPromptModuleRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        version: (_b = o['version']) !== null && _b !== void 0 ? _b : '',
    };
}
export function listPromptModuleRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listPromptModuleRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listPromptModuleRequestFromJson(o) {
    return {
        filters: o['filters'] ? listPromptModuleRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listPromptModuleRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function listPromptModuleRequestFiltersFromJson(o) {
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function listPromptModuleResponseToJson(m) {
    const o = {};
    if (m.promptModules !== undefined) {
        o['promptModules'] = m.promptModules.map(e => promptModuleToJson(e));
    }
    if (m.deployedPromptModuleVersions !== undefined) {
        o['deployedPromptModuleVersions'] = m.deployedPromptModuleVersions.map(e => promptModuleVersionToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listPromptModuleResponseFromJson(o) {
    var _a, _b;
    return {
        promptModules: ((_a = o['promptModules']) !== null && _a !== void 0 ? _a : []).map(e => promptModuleFromJson(e)),
        deployedPromptModuleVersions: ((_b = o['deployedPromptModuleVersions']) !== null && _b !== void 0 ? _b : []).map(e => promptModuleVersionFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function listPromptModuleVersionsRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listPromptModuleVersionsRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listPromptModuleVersionsResponseToJson(m) {
    const o = {};
    if (m.promptModuleVersions !== undefined) {
        o['promptModuleVersions'] = m.promptModuleVersions.map(e => promptModuleVersionToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listPromptModuleVersionsResponseFromJson(o) {
    var _a;
    return {
        promptModuleVersions: ((_a = o['promptModuleVersions']) !== null && _a !== void 0 ? _a : []).map(e => promptModuleVersionFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function deletePromptModuleRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function deletePromptModuleRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function validatePromptModuleRequestToJson(m) {
    const o = {};
    if (m.content !== undefined)
        o['content'] = m.content;
    return o;
}
export function validatePromptModuleRequestFromJson(o) {
    var _a;
    return {
        content: (_a = o['content']) !== null && _a !== void 0 ? _a : '',
    };
}
export function validatePromptModuleResponseToJson(m) {
    const o = {};
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function validatePromptModuleResponseFromJson(o) {
    var _a, _b;
    return {
        isValid: (_a = o['isValid']) !== null && _a !== void 0 ? _a : false,
        errorMessage: (_b = o['errorMessage']) !== null && _b !== void 0 ? _b : '',
    };
}
export function validatePromptModulesRequestToJson(m) {
    const o = {};
    if (m.promptModules !== undefined) {
        o['promptModules'] = m.promptModules.map(e => promptModuleToJson(e));
    }
    return o;
}
export function validatePromptModulesRequestFromJson(o) {
    var _a;
    return {
        promptModules: ((_a = o['promptModules']) !== null && _a !== void 0 ? _a : []).map(e => promptModuleFromJson(e)),
    };
}
export function validatePromptModulesResponseToJson(m) {
    const o = {};
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => validatePromptModulesResponseValidationResultToJson(e));
    }
    if (m.allValid !== undefined)
        o['allValid'] = m.allValid;
    return o;
}
export function validatePromptModulesResponseFromJson(o) {
    var _a, _b;
    return {
        results: ((_a = o['results']) !== null && _a !== void 0 ? _a : []).map(e => validatePromptModulesResponseValidationResultFromJson(e)),
        allValid: (_b = o['allValid']) !== null && _b !== void 0 ? _b : false,
    };
}
export function validatePromptModulesResponseValidationResultToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function validatePromptModulesResponseValidationResultFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        isValid: (_b = o['isValid']) !== null && _b !== void 0 ? _b : false,
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function validatePromptModuleVersionsRequestToJson(m) {
    const o = {};
    if (m.versions !== undefined) {
        o['versions'] = m.versions.map(e => promptModuleVersionToJson(e));
    }
    return o;
}
export function validatePromptModuleVersionsRequestFromJson(o) {
    var _a;
    return {
        versions: ((_a = o['versions']) !== null && _a !== void 0 ? _a : []).map(e => promptModuleVersionFromJson(e)),
    };
}
export function validatePromptModuleVersionsResponseToJson(m) {
    const o = {};
    if (m.results !== undefined) {
        o['results'] = m.results.map(e => validatePromptModuleVersionsResponseValidationResultToJson(e));
    }
    if (m.allValid !== undefined)
        o['allValid'] = m.allValid;
    return o;
}
export function validatePromptModuleVersionsResponseFromJson(o) {
    var _a, _b;
    return {
        results: ((_a = o['results']) !== null && _a !== void 0 ? _a : []).map(e => validatePromptModuleVersionsResponseValidationResultFromJson(e)),
        allValid: (_b = o['allValid']) !== null && _b !== void 0 ? _b : false,
    };
}
export function validatePromptModuleVersionsResponseValidationResultToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.isValid !== undefined)
        o['isValid'] = m.isValid;
    if (m.errorMessage !== undefined)
        o['errorMessage'] = m.errorMessage;
    return o;
}
export function validatePromptModuleVersionsResponseValidationResultFromJson(o) {
    var _a, _b, _c;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        isValid: (_b = o['isValid']) !== null && _b !== void 0 ? _b : false,
        errorMessage: (_c = o['errorMessage']) !== null && _c !== void 0 ? _c : '',
    };
}
export function upsertGoalRequestToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    return o;
}
export function upsertGoalRequestFromJson(o) {
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
    };
}
export function createGoalRequestToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    return o;
}
export function createGoalRequestFromJson(o) {
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
    };
}
export function createGoalResponseToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    return o;
}
export function createGoalResponseFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
    };
}
export function updateGoalRequestToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    if (m.fieldMask !== undefined)
        o['fieldMask'] = fieldMaskToJson(m.fieldMask);
    return o;
}
export function updateGoalRequestFromJson(o) {
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
        fieldMask: o['fieldMask'] ? fieldMaskFromJson(o['fieldMask']) : undefined,
    };
}
export function getGoalRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getGoalRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getGoalResponseToJson(m) {
    const o = {};
    if (m.goal !== undefined)
        o['goal'] = goalToJson(m.goal);
    return o;
}
export function getGoalResponseFromJson(o) {
    return {
        goal: o['goal'] ? goalFromJson(o['goal']) : undefined,
    };
}
export function getMultiGoalRequestToJson(m) {
    const o = {};
    if (m.keys !== undefined) {
        o['keys'] = m.keys.map(e => goalKeyToJson(e));
    }
    return o;
}
export function getMultiGoalRequestFromJson(o) {
    var _a;
    return {
        keys: ((_a = o['keys']) !== null && _a !== void 0 ? _a : []).map(e => goalKeyFromJson(e)),
    };
}
export function getMultiGoalResponseToJson(m) {
    const o = {};
    if (m.goals !== undefined) {
        o['goals'] = m.goals.map(e => goalToJson(e));
    }
    return o;
}
export function getMultiGoalResponseFromJson(o) {
    var _a;
    return {
        goals: ((_a = o['goals']) !== null && _a !== void 0 ? _a : []).map(e => goalFromJson(e)),
    };
}
export function deleteGoalRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.removeFromAssistants !== undefined)
        o['removeFromAssistants'] = m.removeFromAssistants;
    return o;
}
export function deleteGoalRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        removeFromAssistants: (_b = o['removeFromAssistants']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listGoalsRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listGoalsRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listGoalsRequestFromJson(o) {
    return {
        filters: o['filters'] ? listGoalsRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listGoalsRequestSortOptionsToJson(m) {
    const o = {};
    if (m.field !== undefined)
        o['field'] = m.field;
    if (m.order !== undefined)
        o['order'] = m.order;
    return o;
}
export function listGoalsRequestSortOptionsFromJson(o) {
    var _a, _b;
    return {
        field: (_a = o['field']) !== null && _a !== void 0 ? _a : '',
        order: (_b = o['order']) !== null && _b !== void 0 ? _b : 'GOAL_SORTING_ORDER_ASCENDING',
    };
}
export function listGoalsRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.type !== undefined)
        o['type'] = m.type;
    if (m.supportedChannels !== undefined) {
        o['supportedChannels'] = m.supportedChannels.map(e => e);
    }
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => namespaceToJson(e));
    }
    if (m.constraintFilters !== undefined) {
        o['constraintFilters'] = m.constraintFilters.map(e => constraintFilterToJson(e));
    }
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    if (m.sortOptions !== undefined) {
        o['sortOptions'] = m.sortOptions.map(e => listGoalsRequestSortOptionsToJson(e));
    }
    if (m.omitOverrides !== undefined)
        o['omitOverrides'] = m.omitOverrides;
    return o;
}
export function listGoalsRequestFiltersFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        type: (_a = o['type']) !== null && _a !== void 0 ? _a : 'GOAL_TYPE_INVALID',
        supportedChannels: ((_b = o['supportedChannels']) !== null && _b !== void 0 ? _b : []).map(e => e),
        namespaces: ((_c = o['namespaces']) !== null && _c !== void 0 ? _c : []).map(e => namespaceFromJson(e)),
        constraintFilters: ((_d = o['constraintFilters']) !== null && _d !== void 0 ? _d : []).map(e => constraintFilterFromJson(e)),
        searchTerm: (_e = o['searchTerm']) !== null && _e !== void 0 ? _e : '',
        sortOptions: ((_f = o['sortOptions']) !== null && _f !== void 0 ? _f : []).map(e => listGoalsRequestSortOptionsFromJson(e)),
        omitOverrides: (_g = o['omitOverrides']) !== null && _g !== void 0 ? _g : false,
    };
}
export function listGoalsResponseToJson(m) {
    const o = {};
    if (m.goals !== undefined) {
        o['goals'] = m.goals.map(e => goalToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listGoalsResponseFromJson(o) {
    var _a;
    return {
        goals: ((_a = o['goals']) !== null && _a !== void 0 ? _a : []).map(e => goalFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function goalsDisabledForAccountGroupRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function goalsDisabledForAccountGroupRequestFromJson(o) {
    var _a;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function goalsDisabledForAccountGroupResponseToJson(m) {
    const o = {};
    if (m.goalsDisabled !== undefined)
        o['goalsDisabled'] = m.goalsDisabled;
    return o;
}
export function goalsDisabledForAccountGroupResponseFromJson(o) {
    var _a;
    return {
        goalsDisabled: (_a = o['goalsDisabled']) !== null && _a !== void 0 ? _a : false,
    };
}
export function upsertFunctionRequestToJson(m) {
    const o = {};
    if (m.function !== undefined)
        o['function'] = functionToJson(m.function);
    return o;
}
export function upsertFunctionRequestFromJson(o) {
    return {
        function: o['function'] ? functionFromJson(o['function']) : undefined,
    };
}
export function getFunctionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getFunctionRequestFromJson(o) {
    var _a;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getFunctionResponseToJson(m) {
    const o = {};
    if (m.function !== undefined)
        o['function'] = functionToJson(m.function);
    return o;
}
export function getFunctionResponseFromJson(o) {
    return {
        function: o['function'] ? functionFromJson(o['function']) : undefined,
    };
}
export function getMultiFunctionRequestToJson(m) {
    const o = {};
    if (m.keys !== undefined) {
        o['keys'] = m.keys.map(e => functionKeyToJson(e));
    }
    return o;
}
export function getMultiFunctionRequestFromJson(o) {
    var _a;
    return {
        keys: ((_a = o['keys']) !== null && _a !== void 0 ? _a : []).map(e => functionKeyFromJson(e)),
    };
}
export function getMultiFunctionResponseToJson(m) {
    const o = {};
    if (m.functions !== undefined) {
        o['functions'] = m.functions.map(e => functionToJson(e));
    }
    return o;
}
export function getMultiFunctionResponseFromJson(o) {
    var _a;
    return {
        functions: ((_a = o['functions']) !== null && _a !== void 0 ? _a : []).map(e => functionFromJson(e)),
    };
}
export function listFunctionRequestToJson(m) {
    const o = {};
    if (m.filters !== undefined)
        o['filters'] = listFunctionRequestFiltersToJson(m.filters);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    return o;
}
export function listFunctionRequestFromJson(o) {
    return {
        filters: o['filters'] ? listFunctionRequestFiltersFromJson(o['filters']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
    };
}
export function listFunctionRequestFiltersToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.namespaces !== undefined) {
        o['namespaces'] = m.namespaces.map(e => namespaceToJson(e));
    }
    if (m.mcpId !== undefined)
        o['mcpId'] = m.mcpId;
    if (m.constraintFilters !== undefined) {
        o['constraintFilters'] = m.constraintFilters.map(e => constraintFilterToJson(e));
    }
    if (m.searchTerm !== undefined)
        o['searchTerm'] = m.searchTerm;
    return o;
}
export function listFunctionRequestFiltersFromJson(o) {
    var _a, _b, _c, _d;
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        namespaces: ((_a = o['namespaces']) !== null && _a !== void 0 ? _a : []).map(e => namespaceFromJson(e)),
        mcpId: (_b = o['mcpId']) !== null && _b !== void 0 ? _b : '',
        constraintFilters: ((_c = o['constraintFilters']) !== null && _c !== void 0 ? _c : []).map(e => constraintFilterFromJson(e)),
        searchTerm: (_d = o['searchTerm']) !== null && _d !== void 0 ? _d : '',
    };
}
export function listFunctionResponseToJson(m) {
    const o = {};
    if (m.functions !== undefined) {
        o['functions'] = m.functions.map(e => functionToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listFunctionResponseFromJson(o) {
    var _a;
    return {
        functions: ((_a = o['functions']) !== null && _a !== void 0 ? _a : []).map(e => functionFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function deleteFunctionRequestToJson(m) {
    const o = {};
    if (m.id !== undefined)
        o['id'] = m.id;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.removeFromGoals !== undefined)
        o['removeFromGoals'] = m.removeFromGoals;
    return o;
}
export function deleteFunctionRequestFromJson(o) {
    var _a, _b;
    return {
        id: (_a = o['id']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        removeFromGoals: (_b = o['removeFromGoals']) !== null && _b !== void 0 ? _b : false,
    };
}
export function getSessionRequestToJson(m) {
    const o = {};
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.eventTypeFilter !== undefined)
        o['eventTypeFilter'] = m.eventTypeFilter;
    return o;
}
export function getSessionRequestFromJson(o) {
    var _a, _b;
    return {
        sessionId: (_a = o['sessionId']) !== null && _a !== void 0 ? _a : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        eventTypeFilter: (_b = o['eventTypeFilter']) !== null && _b !== void 0 ? _b : 'SESSION_EVENT_TYPE_INVALID',
    };
}
export function getSessionResponseToJson(m) {
    const o = {};
    if (m.session !== undefined)
        o['session'] = sessionToJson(m.session);
    if (m.events !== undefined) {
        o['events'] = m.events.map(e => sessionEventToJson(e));
    }
    if (m.nextCursor !== undefined)
        o['nextCursor'] = m.nextCursor;
    return o;
}
export function getSessionResponseFromJson(o) {
    var _a, _b;
    return {
        session: o['session'] ? sessionFromJson(o['session']) : undefined,
        events: ((_a = o['events']) !== null && _a !== void 0 ? _a : []).map(e => sessionEventFromJson(e)),
        nextCursor: (_b = o['nextCursor']) !== null && _b !== void 0 ? _b : '',
    };
}
export function getSessionEventRequestToJson(m) {
    const o = {};
    if (m.sessionId !== undefined)
        o['sessionId'] = m.sessionId;
    if (m.eventId !== undefined)
        o['eventId'] = m.eventId;
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    return o;
}
export function getSessionEventRequestFromJson(o) {
    var _a, _b;
    return {
        sessionId: (_a = o['sessionId']) !== null && _a !== void 0 ? _a : '',
        eventId: (_b = o['eventId']) !== null && _b !== void 0 ? _b : '',
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
    };
}
export function getSessionEventResponseToJson(m) {
    const o = {};
    if (m.event !== undefined)
        o['event'] = sessionEventToJson(m.event);
    return o;
}
export function getSessionEventResponseFromJson(o) {
    return {
        event: o['event'] ? sessionEventFromJson(o['event']) : undefined,
    };
}
export function listSessionsRequestToJson(m) {
    const o = {};
    if (m.namespace !== undefined)
        o['namespace'] = namespaceToJson(m.namespace);
    if (m.pagingOptions !== undefined)
        o['pagingOptions'] = pagedRequestOptionsToJson(m.pagingOptions);
    if (m.filters !== undefined)
        o['filters'] = listSessionsRequestFiltersToJson(m.filters);
    return o;
}
export function listSessionsRequestFromJson(o) {
    return {
        namespace: o['namespace'] ? namespaceFromJson(o['namespace']) : undefined,
        pagingOptions: o['pagingOptions'] ? pagedRequestOptionsFromJson(o['pagingOptions']) : undefined,
        filters: o['filters'] ? listSessionsRequestFiltersFromJson(o['filters']) : undefined,
    };
}
export function listSessionsRequestFiltersToJson(m) {
    const o = {};
    if (m.tags !== undefined) {
        o['tags'] = m.tags.map(e => e);
    }
    return o;
}
export function listSessionsRequestFiltersFromJson(o) {
    var _a;
    return {
        tags: ((_a = o['tags']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function listSessionsResponseToJson(m) {
    const o = {};
    if (m.sessions !== undefined) {
        o['sessions'] = m.sessions.map(e => sessionToJson(e));
    }
    if (m.metadata !== undefined)
        o['metadata'] = pagedResponseMetadataToJson(m.metadata);
    return o;
}
export function listSessionsResponseFromJson(o) {
    var _a;
    return {
        sessions: ((_a = o['sessions']) !== null && _a !== void 0 ? _a : []).map(e => sessionFromJson(e)),
        metadata: o['metadata'] ? pagedResponseMetadataFromJson(o['metadata']) : undefined,
    };
}
export function vendorStatusToJson(m) {
    const o = {};
    if (m.vendor !== undefined)
        o['vendor'] = m.vendor;
    if (m.available !== undefined)
        o['available'] = m.available;
    return o;
}
export function vendorStatusFromJson(o) {
    var _a, _b;
    return {
        vendor: (_a = o['vendor']) !== null && _a !== void 0 ? _a : '',
        available: (_b = o['available']) !== null && _b !== void 0 ? _b : false,
    };
}
export function listVendorStatusesRequestToJson(m) {
    const o = {};
    return o;
}
export function listVendorStatusesRequestFromJson(o) {
    return {};
}
export function listVendorStatusesResponseToJson(m) {
    const o = {};
    if (m.vendorStatuses !== undefined) {
        o['vendorStatuses'] = m.vendorStatuses.map(e => vendorStatusToJson(e));
    }
    return o;
}
export function listVendorStatusesResponseFromJson(o) {
    var _a;
    return {
        vendorStatuses: ((_a = o['vendorStatuses']) !== null && _a !== void 0 ? _a : []).map(e => vendorStatusFromJson(e)),
    };
}
export function setVendorStatusRequestToJson(m) {
    const o = {};
    if (m.vendor !== undefined)
        o['vendor'] = m.vendor;
    if (m.available !== undefined)
        o['available'] = m.available;
    return o;
}
export function setVendorStatusRequestFromJson(o) {
    var _a, _b;
    return {
        vendor: (_a = o['vendor']) !== null && _a !== void 0 ? _a : '',
        available: (_b = o['available']) !== null && _b !== void 0 ? _b : false,
    };
}
export function setVendorStatusResponseToJson(m) {
    const o = {};
    if (m.vendorStatus !== undefined)
        o['vendorStatus'] = vendorStatusToJson(m.vendorStatus);
    return o;
}
export function setVendorStatusResponseFromJson(o) {
    return {
        vendorStatus: o['vendorStatus'] ? vendorStatusFromJson(o['vendorStatus']) : undefined,
    };
}
export function modelStatusToJson(m) {
    const o = {};
    if (m.model !== undefined)
        o['model'] = m.model;
    if (m.available !== undefined)
        o['available'] = m.available;
    if (m.vendor !== undefined)
        o['vendor'] = m.vendor;
    return o;
}
export function modelStatusFromJson(o) {
    var _a, _b, _c;
    return {
        model: (_a = o['model']) !== null && _a !== void 0 ? _a : '',
        available: (_b = o['available']) !== null && _b !== void 0 ? _b : false,
        vendor: (_c = o['vendor']) !== null && _c !== void 0 ? _c : '',
    };
}
export function listModelStatusesRequestToJson(m) {
    const o = {};
    return o;
}
export function listModelStatusesRequestFromJson(o) {
    return {};
}
export function listModelStatusesResponseToJson(m) {
    const o = {};
    if (m.modelStatuses !== undefined) {
        o['modelStatuses'] = m.modelStatuses.map(e => modelStatusToJson(e));
    }
    return o;
}
export function listModelStatusesResponseFromJson(o) {
    var _a;
    return {
        modelStatuses: ((_a = o['modelStatuses']) !== null && _a !== void 0 ? _a : []).map(e => modelStatusFromJson(e)),
    };
}
export function setModelStatusRequestToJson(m) {
    const o = {};
    if (m.model !== undefined)
        o['model'] = m.model;
    if (m.available !== undefined)
        o['available'] = m.available;
    return o;
}
export function setModelStatusRequestFromJson(o) {
    var _a, _b;
    return {
        model: (_a = o['model']) !== null && _a !== void 0 ? _a : '',
        available: (_b = o['available']) !== null && _b !== void 0 ? _b : false,
    };
}
export function setModelStatusResponseToJson(m) {
    const o = {};
    if (m.modelStatus !== undefined)
        o['modelStatus'] = modelStatusToJson(m.modelStatus);
    return o;
}
export function setModelStatusResponseFromJson(o) {
    return {
        modelStatus: o['modelStatus'] ? modelStatusFromJson(o['modelStatus']) : undefined,
    };
}
